import React, { Component } from "react";
import { connect } from "react-redux";
import RealMap from "../maps/realMap";
import "../../styles/realTime/realTime.scss";
import Layout from "../../Layout/layout";
import { Helmet } from "react-helmet";
import axios from "axios";
import signalRHelper from "../../utils/signalRHelper";
import { apiHost } from "../../api/apiClient";
import NoRecords from "./noRecords";
import { setRealtimeGroup, setRealtimeGroupId, setRealtimeGroupName, setLoadingPage } from "../../reducers/actions";
import { Modal } from "react-bootstrap";
import $ from "jquery";
import { utcToDriverEventDate, utcToReportDate, utcToReportDateWithZone } from "../../utils/dateConvert";
import { rounding, getFriendlyHeading } from "../../utils/math";
import locationCache from "../../utils/locationCache";
import { canAccessVideo } from "../../utils/videoAccess";
import VideoPanel from "../video/VideoPanel";
import VideoUsage from "../video/VideoUsage";

const ENABLE_REALTIME_LIST_ADDRESS_LOOKUP = process.env.REACT_APP_REALTIME_LIST_ADDRESS_LOOKUP !== "false";
const DEFAULT_REALTIME_VISUAL_COLOUR = "#312ec7";
const REALTIME_BACKGROUND_PAUSE_DELAY_MS = 5 * 60 * 1000;
const DRIVER_EVENT_POLL_INTERVAL_MS = 60 * 1000;
const ERP_OVERLAY_REFRESH_INTERVAL_MS = 60 * 1000;
const WEB_DMC_DEVICE_BASE_URL = "https://vttoolsv2-assettrak.visiontrak.com.au/Reports/DMC/dmc_web_device.php?device=";
const getLocalCalendarDate = (date = new Date()) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
const DEFAULT_ADMIN_SMS_COMMAND_PRESETS = [
  { label: "Command 1", command: "STATUS" },
  { label: "Command 2", command: "PING" },
  { label: "Command 3", command: "REBOOT" },
  { label: "Command 4", command: "" },
  { label: "Command 5", command: "" },
];
const LIVE_REPORT_OPTIONS = [
  { value: "/Rpt-MVTL", label: "MVTL" },
  { value: "/Rpt-Visit", label: "Visit Report" },
  { value: "/Temperature", label: "Temperature" },
  { value: "/Replay", label: "Replay" },
  { value: "/Rpt-LocationData", label: "Location" },
  { value: "/Timeline", label: "Timeline" },
  { value: "/Track", label: "Track" },
];

class RealTime extends Component {
  constructor(props) {
    super(props);
    const savedStatusFilter = localStorage.getItem("realTimeStatusFilter");
    const savedVisualMode = localStorage.getItem("realTimeVisualMode");
    const migratedVisualMode = localStorage.getItem("realTimeCustomIconsEnabled") === "true" ? "custom" : "default";
    const isSystemAdmin = localStorage.getItem("role") === "SystemAdmin";
    const allowedVisualModes = isSystemAdmin ? ["default", "ignition", "custom"] : ["default", "ignition"];
    const initialVisualMode = allowedVisualModes.indexOf(savedVisualMode) !== -1
      ? savedVisualMode
      : allowedVisualModes.indexOf(migratedVisualMode) !== -1 ? migratedVisualMode : "default";
    const savedListMapEnabled = localStorage.getItem("realTimeListMapEnabled");
    const savedListMapHeight = localStorage.getItem("realTimeListMapHeight");
    const initialListMapHeight = ["half", "tall", "extraTall"].indexOf(savedListMapHeight) !== -1
      ? savedListMapHeight
      : "half";

    this.state = {
      realTimeData: [],
      videoCameraStatuses: {},
      hasVideoUsage: false,
      connectionCheck: "connection string",
      mapChange: "",
      singleTruckZoom: "",
      followTruckPosition: "",
      groupName: "",
      listgroup: "",
      realTimeGroups: [],
      dataLoading: false,
      isFullScreen: false,
      followSelectedAsset: false,
      scrollLockEnabled: localStorage.getItem("realTimeScrollLock") !== "false",
      mapClusteringEnabled: localStorage.getItem("realTimeMapClustering") !== "false",
      selectedAssetId: "",
      selectedAssetSettings: null,
      selectedAddress: "",
      selectedAddressKey: "",
      selectedAddressLoading: false,
      assetFilter: ["all", "driving", "parked"].indexOf(savedStatusFilter) !== -1 ? savedStatusFilter : "all",
      assetTypeFilter: localStorage.getItem("realTimeTypeFilter") || "all",
      assetSearch: "",
      openReportAssetId: "",
      reportMenuDirection: "down",
      liveQuickReportMenuOpen: false,
      liveQuickReportMenuDirection: "down",
      liveExpandedReportMenuOpen: false,
      mapModalAssetId: "",
      listAddresses: {},
      listAddressSources: {},
      listAddressBatchKey: "",
      devPanelOpen: false,
      userSettingsOpen: false,
      showAddressSourceIndicators: localStorage.getItem("realTimeShowAddressSourceIndicators") !== "false",
      bypassBrowserAddressCache: localStorage.getItem("realTimeBypassBrowserAddressCache") === "true",
      forceHereAddressLookup: localStorage.getItem("realTimeForceHereAddressLookup") === "true",
      realtimeVisualMode: initialVisualMode,
      realtimeTheme: localStorage.getItem("realtimeTheme") || "light",
      realtimeViewMode: localStorage.getItem("realTimeViewMode") || "map",
      listMapEnabled: savedListMapEnabled === null ? true : savedListMapEnabled === "true",
      listMapHeight: initialListMapHeight,
      liveReportMode: localStorage.getItem("realTimeLiveReportMode") === "expanded" ? "expanded" : "quick",
      liveReportPosition: localStorage.getItem("realTimeLiveReportPosition") === "top" ? "top" : "bottom",
      liveReportType: "/Track",
      liveReportDate: getLocalCalendarDate(),
      adminAssetModalOpen: false,
      assetSettingsModalOpen: false,
      adminSmsDestinationNumber: "",
      adminSmsContent: "",
      adminSmsSending: false,
      adminSmsResult: null,
      adminSmsMessages: [],
      adminSmsMessagesLoading: false,
      adminSmsPresets: DEFAULT_ADMIN_SMS_COMMAND_PRESETS,
      adminSmsPresetEditorOpen: false,
      adminSmsPresetLoading: false,
      adminSmsPresetSaving: false,
      assetCommandStatusLoading: false,
      assetCommandStatus: null,
      odometerInputKm: "",
      odometerSubmitting: false,
      odometerResult: null,
      odometerSteps: [],
      odometerJobId: "",
      copiedButtonKey: "",
      userAssetColourOverrides: {},
      assetColourInput: "",
      assetColourResult: null,
      realtimeListLastRefreshed: null,
      driverAssetEvent: null,
      driverAssetEventAssetId: "",
      criticalFailureModalOpen: false,
      criticalFailureLoading: false,
      criticalFailureError: "",
      criticalFailureDetails: null,
      latestDriverIncident: null,
      driverIncidents: [],
      driverIncidentsHasMore: false,
      driverIncidentsFailed: false,
      incidentAcknowledgementPending: null,
      incidentAcknowledgementSaving: false,
      incidentActionMessage: "",
      incidentModalOpen: false,
      modalDriverIncident: null,
      incidentLinkMessage: "",
      erpOverlayLoading: false,
      erpOverlayAvailable: false,
      erpStops: [],
      erpGeofences: [],
      erpProgress: null,
      erpGeofencesVisible: localStorage.getItem("realTimeErpGeofencesVisible") !== "false",
      erpStopsPanelHidden: localStorage.getItem("realTimeErpStopsPanelHidden") === "true",
      erpOverlayAssetId: "",
      erpCustomerEnabled: false,
    };

    this.currentList = [];
    this.pendingMapUpdates = {};
    this.realtimeUpdateTimer = null;
    this.listAddressTimer = null;
    this.adminSmsPollTimer = null;
    this.odometerStatusPollTimer = null;
    this.odometerJobPollTimer = null;
    this.driverEventPollTimer = null;
    this.backgroundPauseTimer = null;
    this.copyFeedbackTimer = null;
    this.listAddressRequestId = 0;
    this.driverEventRequestId = 0;
    this.realtimePaused = false;
    this.initialMount = true; // Add a flag to track initial mount
    this.adminSmsThreadRef = React.createRef();
    this.listMapRef = React.createRef();
    this.erpCapabilityCache = {};
    this.erpCapabilityRequests = {};
    this.erpCapabilityRetryCounts = {};
    this.erpCapabilityRetryTimer = null;
    this.erpProgressBootstrapRequests = {};
    this.erpOverlayRefreshTimer = null;
    this.erpOverlayRequests = {};
  }

  async componentDidMount() {
    this.realtimeMounted = true;
    this.loadVideoUsageAvailability();
    this.videoStatusTimer = setInterval(this.refreshVideoCameraStatuses, 30000);
    window.addEventListener("driver-incidents-changed", this.handleIncidentChange);
    window.addEventListener("storage", this.handleIncidentChange);
    if (localStorage.getItem("realTimeGroupId")) {
      this.props.setRealtimeGroupIdAction(localStorage.getItem("realTimeGroupId"));
      this.props.setRealtimeGroupNameAction(localStorage.getItem("realTimeGroupName"));
    }

    this.setGroupList().then(() => {
      this.realtimeGroupsReady = true;
      this.openIncidentDeepLink();
    });
    this.handleSignalR();
    this.loadUserAssetVisualPreferences();
    this.erpOverlayRefreshTimer = setInterval(this.refreshErpOverlay, ERP_OVERLAY_REFRESH_INTERVAL_MS);
    
    // Add fullscreen change event listeners
    document.addEventListener("fullscreenchange", this.handleFullscreenChange);
    document.addEventListener("webkitfullscreenchange", this.handleFullscreenChange);
    document.addEventListener("mozfullscreenchange", this.handleFullscreenChange);
    document.addEventListener("MSFullscreenChange", this.handleFullscreenChange);
    document.addEventListener("click", this.closeReportMenu);
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
  }

  componentDidUpdate(prevProps, prevState) {
    if ((this.props.location.search !== prevProps.location.search || this.props.location.key !== prevProps.location.key) && this.realtimeGroupsReady) this.openIncidentDeepLink();
    if (this.state.realTimeData !== prevState.realTimeData) this.queueVideoCameraStatusRefresh();
    // Initial group selection is loaded once by setGroupList after validating saved access.
    if (this.realtimeGroupsReady && this.props.realTimeGroupId != prevProps.realTimeGroupId) {
      if (String(this.incidentGroupTarget) !== String(this.props.realTimeGroupId)) {
        this.incidentLinkRequest = (this.incidentLinkRequest || 0) + 1;
        this.setGroup(this.props.realTimeGroupId);
      }
      this.incidentGroupTarget = null;
      this.loadErpCapabilityForSelectedGroup();
    }

    if (
      this.state.realTimeGroups !== prevState.realTimeGroups &&
      this.state.realTimeGroups.length &&
      this.props.realTimeGroupId
    ) {
      this.loadErpCapabilityForSelectedGroup();
    }

    if (this.state.selectedAssetId !== prevState.selectedAssetId) {
      this.startDriverEventPolling(this.state.selectedAssetId);
      this.loadErpOverlayForSelectedAsset();
    } else if (
      this.state.erpCustomerEnabled &&
      this.state.selectedAssetId &&
      this.state.realTimeData !== prevState.realTimeData &&
      String(this.state.erpOverlayAssetId || "") !== String(this.state.selectedAssetId) &&
      !this.state.erpOverlayLoading
    ) {
      this.loadErpOverlayForSelectedAsset();
    } else if (
      this.state.erpOverlayAvailable &&
      this.state.selectedAssetId &&
      this.state.realTimeData !== prevState.realTimeData
    ) {
      this.updateErpProgressForSelectedAsset();
    }

    if (
      this.state.adminAssetModalOpen &&
      this.state.adminSmsMessages.length &&
      this.state.adminSmsMessages !== prevState.adminSmsMessages
    ) {
      this.scrollAdminSmsThreadToBottom();
    }

    var selectedAsset = this.getSelectedAsset(this.getActiveAssets(this.state.realTimeData));
    var selectedAddressKey = this.getAddressKey(selectedAsset);

    if (selectedAddressKey && selectedAddressKey !== this.state.selectedAddressKey) {
      this.loadSelectedAddress(selectedAsset);
    } else if (!selectedAddressKey && this.state.selectedAddressKey) {
      this.setState({ selectedAddress: "", selectedAddressKey: "", selectedAddressLoading: false });
    }

    if (!this.realtimePaused && ENABLE_REALTIME_LIST_ADDRESS_LOOKUP && this.state.realtimeViewMode === "list") {
      this.queueListAddressBatch(this.filterAssetList(this.getActiveAssets(this.state.realTimeData)));
    }
  }

  setSpecificGroup = value => this.loadRealtimeGroup(value);
  setAllGroup = () => this.loadRealtimeGroup("all");
  setGroup = groupId => this.loadRealtimeGroup(groupId);

  loadRealtimeGroup = async groupId => {
    const requestId = this.realtimeGroupRequest = (this.realtimeGroupRequest || 0) + 1;
    this.clearQueuedRealtimeUpdates();
    this.props.setLoadingPageAction(true);
    const all = !groupId || groupId === "all" || groupId === 0;
    if (all) signalRHelper.resetGroupFilter();
    else signalRHelper.setGroupFilter(groupId);
    this.setState({ dataLoading: true, groupName: all ? "" : this.props.realTimeGroupName });
    try {
      const response = await axios.get(`${apiHost}/api/Assets/AssetsByCustomerIdWithIMEI${all ? "" : `?GroupId=${encodeURIComponent(groupId)}`}`, {
        headers: this.getAuthHeaders(),
      });
      if (!this.realtimeMounted || requestId !== this.realtimeGroupRequest) return null;
      const assets = (response.data || []).map(asset => this.normalizeRealtimeAssetMetadata(asset));
      this.currentList = assets;
      await new Promise(resolve => this.setState({ realTimeData: assets, realtimeListLastRefreshed: new Date() }, resolve));
      return assets;
    } catch (error) {
      if (this.realtimeMounted && error.response?.status === 401) this.props.history.push("/login");
      console.warn("Realtime group load failed", error.response?.status || "network error");
      return null;
    } finally {
      if (this.realtimeMounted && requestId === this.realtimeGroupRequest) {
        this.setState({ dataLoading: false });
        this.props.setLoadingPageAction(false);
      }
    }
  };

  openIncidentDeepLink = async () => {
    this.incidentDetailRequest = (this.incidentDetailRequest || 0) + 1;
    const requestId = this.incidentLinkRequest = (this.incidentLinkRequest || 0) + 1;
    const params = new URLSearchParams(this.props.location.search);
    const assetId = params.get("assetId"), incidentId = params.get("incidentId");
    if (!this.realtimeMounted) return;
    this.setState({ incidentLinkMessage: "", modalDriverIncident: null, incidentAcknowledgementPending: null, incidentActionMessage: "", incidentModalOpen: false });
    if (!incidentId) return;
    if (!assetId || !/^[1-9][0-9]*$/.test(incidentId)) {
      this.setState({ incidentLinkMessage: "This incident link is invalid." });
      return;
    }
    const current = () => this.realtimeMounted && requestId === this.incidentLinkRequest;
    this.setState({ incidentLinkMessage: "Opening incident…" });
    try {
      const response = await axios.get(`${apiHost}/api/Assets/${encodeURIComponent(assetId)}/DriverIncidents/${encodeURIComponent(incidentId)}`, { headers: this.getAuthHeaders() });
      if (!current()) return;
      const incident = response.data;
      if (!incident) throw new Error("Incident unavailable");
      const group = incident.realtimeGroup;
      const groupId = group ? group.groupId : "all";
      const groupName = group ? `${group.customerName} - ${group.groupName}` : "All groups";
      this.incidentGroupTarget = groupId;
      this.props.setRealtimeGroupNameAction(groupName);
      this.props.setRealtimeGroupIdAction(groupId);
      localStorage.setItem("realTimeGroupId", groupId);
      localStorage.setItem("realTimeGroupName", groupName);
      const assets = await this.setGroup(groupId);
      if (!current()) return;
      const asset = (assets || []).find(item => String(this.getAssetId(item)).toLowerCase() === assetId.toLowerCase());
      if (!asset) throw new Error("Asset unavailable in Realtime");
      this.setState({ assetSearch: "", assetFilter: "all", assetTypeFilter: "all" });
      this.handleAssetSelect(asset);
      // Let selection lifecycle start its normal latest-event poll before opening this modal.
      await new Promise(resolve => this.setState({}, resolve));
      const photos = await axios.get(`${apiHost}/api/Assets/${encodeURIComponent(assetId)}/DriverIncidents/${encodeURIComponent(incidentId)}/Photos`, { headers: this.getAuthHeaders() });
      if (!current() || String(this.state.selectedAssetId).toLowerCase() !== assetId.toLowerCase()) return;
      this.setState({ modalDriverIncident: { ...incident, photos: photos.data || [] }, incidentModalOpen: true, incidentLinkMessage: "" });
    } catch (error) {
      if (current()) this.setState({ incidentLinkMessage: "Unable to open this incident. It may be unavailable, outside your access, or its asset may no longer be active in Realtime." });
    }
  };

  handleGroupSelection = (event) => {
    var selectedOption = event.target.options[event.target.selectedIndex];
    var groupId = event.target.value;
    var groupName = selectedOption.getAttribute("data-group-name");

    this.props.setRealtimeGroupIdAction(groupId);
    this.props.setRealtimeGroupNameAction(groupName);
    localStorage.setItem("realTimeGroupId", groupId);
    localStorage.setItem("realTimeGroupName", groupName);
  };

  handleFullScreen = () => {
    const elem = $("#realMapContainer")[0];
    
    if (!this.state.isFullScreen) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
  };

  clearSelectedAsset = () => {
    this.setFollowSelectedAsset(false);
    this.setState({
      selectedAssetId: "",
      selectedAssetSettings: null,
      selectedAddress: "",
      selectedAddressKey: "",
      selectedAddressLoading: false,
      driverAssetEvent: null,
      driverAssetEventAssetId: "",
    });
  };
  
  handleFullscreenChange = () => {
    const isFullScreen = 
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement;
      
    this.setState({ isFullScreen: !!isFullScreen });
  };

  setGroupList = async () => {
    try {
      const response = await axios.get(`${apiHost}/api/Assets/GroupsByCurrentUser`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      });

      if (response.status == "200") {
        var groups = response.data || [];
        this.setState({ listgroup: groups[0] || "", realTimeGroups: groups });

        if (groups.length > 0) {
          this.props.setRealtimeGroupAction(groups);

          var storedGroupId = localStorage.getItem("realTimeGroupId");
          var selectedGroup = groups.find((group) => String(group.groupId) === String(storedGroupId)) || groups[0];
          var selectedGroupName = `${selectedGroup.customername} - ${selectedGroup.groupName}`;

          if (String(this.props.realTimeGroupId) !== String(selectedGroup.groupId)) {
            this.props.setRealtimeGroupIdAction(selectedGroup.groupId);
          }
          this.props.setRealtimeGroupNameAction(selectedGroupName);
          localStorage.setItem("realTimeGroupId", selectedGroup.groupId);
          localStorage.setItem("realTimeGroupName", selectedGroupName);
          await this.setGroup(selectedGroup.groupId);
        } else {
          this.props.setRealtimeGroupAction([]);
          await this.setAllGroup();
        }
      }
    } catch (e) {
      if (e.response?.status == "401") {
        this.props.history.push("/login");
      }
      console.log(`😱 Axios request failed: ${e}`);
    }
  };

  async handleSignalR() {
    this.connection = await signalRHelper.getConnection();
    this.addTransferChartDataListener();
  }

  componentWillUnmount() {
    this.realtimeMounted = false;
    clearInterval(this.videoStatusTimer);
    clearTimeout(this.videoStatusRefreshTimer);
    window.removeEventListener("driver-incidents-changed", this.handleIncidentChange);
    window.removeEventListener("storage", this.handleIncidentChange);
    this.incidentLinkRequest = (this.incidentLinkRequest || 0) + 1;
    if (this.realtimeUpdateTimer) {
      clearTimeout(this.realtimeUpdateTimer);
      this.realtimeUpdateTimer = null;
    }
    if (this.listAddressTimer) {
      clearTimeout(this.listAddressTimer);
      this.listAddressTimer = null;
    }
    if (this.erpCapabilityRetryTimer) {
      clearTimeout(this.erpCapabilityRetryTimer);
      this.erpCapabilityRetryTimer = null;
    }
    if (this.copyFeedbackTimer) {
      clearTimeout(this.copyFeedbackTimer);
      this.copyFeedbackTimer = null;
    }
    if (this.erpOverlayRefreshTimer) {
      clearInterval(this.erpOverlayRefreshTimer);
      this.erpOverlayRefreshTimer = null;
    }
    this.stopDriverEventPolling();
    this.clearBackgroundPauseTimer();
    this.stopAdminSmsPolling();
    this.stopOdometerStatusPolling();
    this.stopOdometerJobPolling();
    this.releaseSignalR();
    
    // Remove fullscreen change event listeners
    document.removeEventListener("fullscreenchange", this.handleFullscreenChange);
    document.removeEventListener("webkitfullscreenchange", this.handleFullscreenChange);
    document.removeEventListener("mozfullscreenchange", this.handleFullscreenChange);
    document.removeEventListener("MSFullscreenChange", this.handleFullscreenChange);
    document.removeEventListener("click", this.closeReportMenu);
    document.removeEventListener("visibilitychange", this.handleVisibilityChange);
  }

  releaseSignalR() {
    if (!this.connection) {
      return;
    }
    // Release signalR handlers
    signalRHelper.unsubscribe("RealTimeMap");
    signalRHelper.resetAssetFilter();
    signalRHelper.resetGroupFilter();

    this.connection.off("RealTimeMap");
    this.connection = null;
  }

  addTransferChartDataListener = () => {
    signalRHelper.subscribe("RealTimeMap");

    this.connection.on("RealTimeMap", (data) => {
      if (this.realtimePaused) return;

      var realtimeAsset = this.normalizeRealtimeAssetMetadata(data);
      this.data = realtimeAsset;
      this.createNewList(realtimeAsset);
      this.queueMapUpdate(realtimeAsset);
      this.refreshSelectedAssetDetails(realtimeAsset);
      this.scheduleRealtimeFlush();
    });
  };

  handleVisibilityChange = () => {
    if (!document.hidden) this.refreshVideoCameraStatuses();
    if (document.hidden) {
      this.scheduleBackgroundPause();
    } else {
      this.clearBackgroundPauseTimer();
      this.resumeRealtimeUpdates();
      this.refreshErpOverlay();
    }
  };

  scheduleBackgroundPause = () => {
    this.clearBackgroundPauseTimer();

    this.backgroundPauseTimer = setTimeout(() => {
      this.backgroundPauseTimer = null;
      if (document.hidden) {
        this.pauseRealtimeUpdates();
      }
    }, REALTIME_BACKGROUND_PAUSE_DELAY_MS);
  };

  clearBackgroundPauseTimer = () => {
    if (this.backgroundPauseTimer) {
      clearTimeout(this.backgroundPauseTimer);
      this.backgroundPauseTimer = null;
    }
  };

  pauseRealtimeUpdates = () => {
    if (this.realtimePaused) return;

    this.realtimePaused = true;
    signalRHelper.unsubscribe("RealTimeMap");

    if (this.realtimeUpdateTimer) {
      clearTimeout(this.realtimeUpdateTimer);
      this.realtimeUpdateTimer = null;
    }

    if (this.listAddressTimer) {
      clearTimeout(this.listAddressTimer);
      this.listAddressTimer = null;
    }

    this.pendingMapUpdates = {};
    this.listAddressRequestId += 1;
  };

  resumeRealtimeUpdates = () => {
    if (!this.realtimePaused) return;

    this.realtimePaused = false;
    signalRHelper.subscribe("RealTimeMap");

    var groupId = this.props.realTimeGroupId || localStorage.getItem("realTimeGroupId");
    if (groupId) {
      this.setGroup(groupId);
    }
  };

  clearQueuedRealtimeUpdates = () => {
    this.pendingMapUpdates = {};
  };

  queueMapUpdate = (data) => {
    var assetId = this.getAssetId(data);
    if (!assetId) return;

    this.pendingMapUpdates[assetId] = data;
  };

  updateMapNow = (data) => {
    var assetId = this.getAssetId(data);
    if (!assetId) return;

    delete this.pendingMapUpdates[assetId];
    this.setState({ mapChange: JSON.stringify([data]) });
  };

  flushMapUpdates = () => {
    var updates = Object.keys(this.pendingMapUpdates)
      .map((assetId) => this.pendingMapUpdates[assetId])
      .filter((asset) => this.filterAssets([asset]).length > 0);
    if (!updates.length) return;

    this.pendingMapUpdates = {};
    this.setState({ mapChange: JSON.stringify(updates) });
  };

  flushRealtimeUpdates = () => {
    this.realtimeUpdateTimer = null;
    this.setState({ realTimeData: [...this.currentList], realtimeListLastRefreshed: new Date() });
    this.flushMapUpdates();
  };

  scheduleRealtimeFlush = () => {
    if (this.realtimeUpdateTimer) return;
    this.realtimeUpdateTimer = setTimeout(this.flushRealtimeUpdates, 750);
  };

  createNewList = (data) => {
    var assetId = this.getAssetId(data);
    var isIdentified = this.currentList.some((item) => String(this.getAssetId(item)) === String(assetId));

    if (!isIdentified) {
      this.currentList.push(data);
    } else {
      this.currentList.forEach((list, index) => {
        if (String(this.getAssetId(list)) === String(assetId)) {
          this.currentList[index] = data;
        }
      });
    }
  };

  refreshSelectedAssetDetails = (data) => {
    var assetId = this.getAssetId(data);
    if (!data || String(assetId) !== String(this.state.selectedAssetId)) return;

    this.setState((state) => ({
      realTimeData: state.realTimeData.map((asset) =>
        String(this.getAssetId(asset)) === String(assetId) ? data : asset
      ),
    }));

    if (this.state.followSelectedAsset) {
      var location = this.getLocation(data);
      this.updateMapNow(data);
      if (location) {
        this.handleTruckFollow(location);
      }
    }
  };

  handleTruckSelection = (data) => {
    this.setState({ singleTruckZoom: data });
  };

  handleTruckFollow = (data) => {
    this.setState({ followTruckPosition: data });
  };

  getValue = (source, keys) => {
    if (!source) return undefined;
    for (var index = 0; index < keys.length; index++) {
      if (source[keys[index]] !== undefined && source[keys[index]] !== null) {
        return source[keys[index]];
      }
    }
    return undefined;
  };

  getUserAssetColourStorageKey = () => {
    var userId = localStorage.getItem("userId") || "anonymous";
    return `realTimeAssetColourOverrides:${userId}`;
  };

  loadUserAssetColourOverrides = () => {
    try {
      var value = localStorage.getItem(this.getUserAssetColourStorageKey());
      var overrides = value ? JSON.parse(value) : {};
      return overrides && typeof overrides === "object" && !Array.isArray(overrides) ? overrides : {};
    } catch (e) {
      return {};
    }
  };

  saveUserAssetColourOverrides = (overrides) => {
    localStorage.setItem(this.getUserAssetColourStorageKey(), JSON.stringify(overrides || {}));
  };

  getAuthHeaders = () => ({
    Authorization: "Bearer " + localStorage.getItem("token"),
  });

  normalizeUserAssetVisualPreferences = (preferences) => {
    var overrides = {};
    (preferences || []).forEach((preference) => {
      var assetId = this.getValue(preference, ["assetId", "AssetId"]);
      var colour = this.normalizeColourValue(this.getValue(preference, ["colour", "Colour"]));
      if (assetId && colour) {
        overrides[String(assetId)] = colour;
      }
    });
    return overrides;
  };

  loadUserAssetVisualPreferences = async () => {
    try {
      var response = await axios.get(`${apiHost}/api/Assets/VisualPreferences`, {
        headers: this.getAuthHeaders(),
      });
      var overrides = this.normalizeUserAssetVisualPreferences(response.data);
      this.saveUserAssetColourOverrides(overrides);
      this.setState({ userAssetColourOverrides: overrides });
    } catch (e) {
      this.setState({ userAssetColourOverrides: this.loadUserAssetColourOverrides() });
      if (e && e.response && e.response.status == "401") {
        this.props.history.push("/login");
      }
    }
  };

  normalizeColourValue = (value) => {
    var colour = String(value || "").trim();
    if (!colour) return "";
    if (colour[0] !== "#") colour = `#${colour}`;
    return /^#[0-9a-fA-F]{6}$/.test(colour) ? colour.toLowerCase() : "";
  };

  getUserAssetColourOverride = (asset) => {
    var assetId = this.getAssetId(asset);
    if (!assetId) return "";
    return this.state.userAssetColourOverrides[String(assetId)] || "";
  };

  canUseUserAssetColourOverride = () => this.state.realtimeVisualMode === "default";

  applyUserAssetColourOverride = (asset) => {
    if (!asset || !this.canUseUserAssetColourOverride()) return asset;

    var overrideColour = this.getUserAssetColourOverride(asset);
    if (!overrideColour) return asset;

    return {
      ...asset,
      colour: overrideColour,
      Colour: overrideColour,
      userColourOverride: overrideColour,
    };
  };

  getMapChangeWithUserAssetColourOverrides = (mapChange) => {
    if (!mapChange || !this.canUseUserAssetColourOverride()) return mapChange;

    try {
      var updates = JSON.parse(mapChange);
      if (!Array.isArray(updates)) updates = [updates];
      return JSON.stringify(updates.map((asset) => this.applyUserAssetColourOverride(asset)));
    } catch (e) {
      return mapChange;
    }
  };

  getSelectedGroupVisualSettings = () => {
    var groupId = this.props.realTimeGroupId || localStorage.getItem("realTimeGroupId");
    if (!groupId || groupId === "all") return {};

    var groups = this.state.realTimeGroups.length ? this.state.realTimeGroups : this.props.realTimeGroup || [];
    var selectedGroup = groups.find((group) => String(group.id || group.groupId || group.groupID) === String(groupId));
    if (!selectedGroup) return {};

    return {
      groupColour: this.getValue(selectedGroup, ["colour", "Colour", "color", "Color"]),
      groupIcon: this.getValue(selectedGroup, ["icon", "Icon"]),
    };
  };

  getAssetId = (asset) => {
    return this.getValue(asset, ["assetId", "AssetId", "assetID", "AssetID", "id", "Id"]);
  };

  getErpAssetRegistration = (asset) => String(this.getValue(asset, [
    "registration", "Registration", "vehicleRegistration", "VehicleRegistration",
    "assetName", "AssetName", "name", "Name", "friendlyName", "FriendlyName"
  ]) || "").trim();

  getErpCustomerId = (asset) => {
    const assetCustomerId = this.getValue(asset, ["customerId", "CustomerId", "customerID", "CustomerID"]);
    if (assetCustomerId) return String(assetCustomerId);
    const groupId = this.props.realTimeGroupId || localStorage.getItem("realTimeGroupId");
    const groups = this.state.realTimeGroups.length ? this.state.realTimeGroups : (this.props.realTimeGroup || []);
    const group = groups.find((item) => String(this.getValue(item, ["groupId", "GroupId", "id", "Id"])) === String(groupId));
    return String(this.getValue(group, ["customerId", "CustomerId", "customerID", "CustomerID"]) || "");
  };

  getErpAssetIdentifiers = (asset) => {
    const values = [
      this.getErpAssetRegistration(asset),
      this.getValue(asset, ["friendlyName", "FriendlyName"]),
      this.getValue(asset, ["registration", "Registration", "vehicleRegistration", "VehicleRegistration"]),
      this.getValue(asset, ["assetName", "AssetName", "name", "Name"])
    ];
    const identifiers = [];
    values.forEach((value) => {
      const normalised = String(value || "").trim().toLowerCase();
      if (normalised && identifiers.indexOf(normalised) === -1) identifiers.push(normalised);
      const bracketMatch = normalised.match(/\(([^)]+)\)\s*$/);
      if (bracketMatch && identifiers.indexOf(bracketMatch[1].trim()) === -1) identifiers.push(bracketMatch[1].trim());
    });
    return identifiers;
  };

  getErpDayKey = () => new Intl.DateTimeFormat("en-CA", {
    timeZone: "Australia/Melbourne", year: "numeric", month: "2-digit", day: "2-digit"
  }).format(new Date());

  loadErpCapabilityForSelectedGroup = async () => {
    const customerId = this.getErpCustomerId(null);
    if (!customerId && this.isSystemAdmin()) {
      this.setState({ erpCustomerEnabled: false, erpOverlayAvailable: false, erpStops: [], erpGeofences: [], erpProgress: null, erpOverlayAssetId: "" });
      return;
    }
    const cacheKey = customerId || "current-user-customer";
    if (this.erpCapabilityCache[cacheKey] !== undefined) {
      const enabled = this.erpCapabilityCache[cacheKey];
      this.setState({ erpCustomerEnabled: enabled }, enabled ? this.loadErpOverlayForSelectedAsset : undefined);
      return;
    }
    if (this.erpCapabilityRequests[cacheKey]) return this.erpCapabilityRequests[cacheKey];
    const request = (async () => {
      try {
        const customerQuery = customerId ? `?customerId=${encodeURIComponent(customerId)}` : "";
        const response = await axios.get(`${apiHost}/api/RunSheets/capability${customerQuery}`, {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") }
        });
        const enabled = !!(response.data && response.data.enabled);
        this.erpCapabilityCache[cacheKey] = enabled;
        delete this.erpCapabilityRetryCounts[cacheKey];
        const currentCustomerId = this.getErpCustomerId(null);
        const currentKey = currentCustomerId || "current-user-customer";
        if (currentKey !== cacheKey) return;
        this.setState({ erpCustomerEnabled: enabled, erpOverlayAvailable: false, erpStops: [], erpGeofences: [], erpProgress: null, erpOverlayAssetId: "" }, enabled ? this.loadErpOverlayForSelectedAsset : undefined);
      } catch (_) {
        const currentCustomerId = this.getErpCustomerId(null);
        const currentKey = currentCustomerId || "current-user-customer";
        if (currentKey !== cacheKey) return;
        const retryCount = Number(this.erpCapabilityRetryCounts[cacheKey] || 0) + 1;
        this.erpCapabilityRetryCounts[cacheKey] = retryCount;
        this.setState({ erpCustomerEnabled: false, erpOverlayAvailable: false, erpStops: [], erpGeofences: [], erpProgress: null, erpOverlayAssetId: "" });
        if (retryCount <= 2 && !this.erpCapabilityRetryTimer) {
          this.erpCapabilityRetryTimer = setTimeout(() => {
            this.erpCapabilityRetryTimer = null;
            this.loadErpCapabilityForSelectedGroup();
          }, retryCount * 1500);
        }
      } finally {
        delete this.erpCapabilityRequests[cacheKey];
      }
    })();
    this.erpCapabilityRequests[cacheKey] = request;
    return request;
  };

  getErpProgressKey = (assetId) => `realTimeErpProgress:${assetId}:${this.getErpDayKey()}`;

  haversineMeters = (lat1, lng1, lat2, lng2) => {
    const toRad = (value) => value * Math.PI / 180;
    const earthRadiusM = 6371000;
    const dLat = toRad(lat2 - lat1);
    const dLng = toRad(lng2 - lng1);
    const a = Math.sin(dLat / 2) ** 2 + Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
    return earthRadiusM * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  };

  refreshErpOverlay = () => {
    if (document.hidden || !this.state.erpCustomerEnabled || !this.state.selectedAssetId || this.state.erpOverlayLoading) return;
    this.loadErpOverlayForSelectedAsset(true);
  };

  loadErpOverlayForSelectedAsset = async (silent = false) => {
    const asset = this.getSelectedAsset(this.getActiveAssets(this.state.realTimeData));
    const assetId = this.getAssetId(asset);
    if (!assetId) {
      this.setState({ erpOverlayLoading: false, erpOverlayAvailable: false, erpStops: [], erpGeofences: [], erpProgress: null, erpOverlayAssetId: "" });
      return;
    }
    if (!this.state.erpCustomerEnabled) return;
    const requestKey = String(assetId);
    if (this.erpOverlayRequests[requestKey]) return this.erpOverlayRequests[requestKey];

    if (!silent) {
      this.setState({ erpOverlayLoading: true, erpOverlayAvailable: false, erpStops: [], erpGeofences: [], erpProgress: null, erpOverlayAssetId: requestKey });
    }
    const headers = { Authorization: "Bearer " + localStorage.getItem("token") };
    const request = (async () => {
      try {
        const response = await axios.get(`${apiHost}/api/RunSheets/realtime-overlay?assetId=${encodeURIComponent(assetId)}`, { headers });
        if (String(this.state.selectedAssetId) !== requestKey) return;
        const stops = (response.data && response.data.stops) || [];
        const geofences = (response.data && response.data.geofences) || [];
        let saved = this.state.erpOverlayAssetId === requestKey ? this.state.erpProgress : null;
        if (!saved) {
          try { saved = JSON.parse(localStorage.getItem(this.getErpProgressKey(assetId)) || "null"); } catch (_) {}
        }
        const stopStates = { ...((saved && saved.stopStates) || {}) };
        stops.forEach((stop) => {
          const key = String(stop.dropNumber);
          if (!stopStates[key]) stopStates[key] = { status: "pending", enteredAt: null, exitedAt: null };
        });
        const progress = { currentStopNo: null, lastCompletedStopNo: null, lastPingMs: 0, bootstrappedAt: 0, ...(saved || {}), stopStates };
        this.setState({ erpOverlayLoading: false, erpOverlayAvailable: !!(response.data && response.data.mapped), erpStops: stops, erpGeofences: geofences, erpProgress: progress, erpOverlayAssetId: requestKey }, () => {
          this.bootstrapErpProgressFromHistory(asset).then(this.updateErpProgressForSelectedAsset);
        });
      } catch (error) {
        if (String(this.state.selectedAssetId) !== requestKey) return;
        if (!silent) this.setState({ erpOverlayLoading: false, erpOverlayAvailable: false, erpStops: [], erpGeofences: [], erpProgress: null });
        if (!(error && error.response && error.response.status === 404)) console.warn("ERP realtime overlay could not be loaded");
      } finally {
        delete this.erpOverlayRequests[requestKey];
      }
    })();
    this.erpOverlayRequests[requestKey] = request;
    return request;
  };

  bootstrapErpProgressFromHistory = async (asset) => {
    const assetId = this.getAssetId(asset);
    if (!assetId || !this.state.erpOverlayAvailable || !this.state.erpProgress || !this.state.erpGeofences.length) return;
    const dayKey = this.getErpDayKey();
    const requestKey = `${assetId}|${dayKey}`;
    const lastBootstrap = Number(this.state.erpProgress.bootstrappedAt || 0);
    if (lastBootstrap && Date.now() - lastBootstrap < 5 * 60 * 1000) return;
    if (this.erpProgressBootstrapRequests[requestKey]) return this.erpProgressBootstrapRequests[requestKey];

    const request = (async () => {
      try {
        const response = await axios.get(`${apiHost}/api/RunSheets/realtime-history`, {
          params: { assetId, runDate: dayKey },
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        });
        if (String(this.state.selectedAssetId) !== String(assetId)) return;
        const records = (response.data && response.data.records) || [];
        const progress = { ...this.state.erpProgress, stopStates: { ...this.state.erpProgress.stopStates } };
        const byStopNo = new Map();
        this.state.erpGeofences.forEach((geofence) => {
          const stopNo = Number(geofence.firstDrop);
          const lat = Number(geofence.lat);
          const lng = Number(geofence.lng);
          if (!Number.isFinite(stopNo) || stopNo <= 0 || !Number.isFinite(lat) || !Number.isFinite(lng)) return;
          byStopNo.set(stopNo, {
            stopNo,
            lat,
            lng,
            radius: Math.max(50, Number(geofence.radiusM) || 0),
          });
        });
        const inFence = new Map();
        let lastPingMs = Number(progress.lastPingMs || 0);

        records.forEach((record) => {
          const lat = Number(record.lat ?? record.Lat);
          const lng = Number(record.lng ?? record.Lng);
          if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;
          const rawCreated = record.createdUtc ?? record.CreatedUtc;
          const pingMs = rawCreated ? new Date(rawCreated).getTime() : 0;
          if (Number.isFinite(pingMs) && pingMs > lastPingMs) lastPingMs = pingMs;
          const timeLabel = Number.isFinite(pingMs) && pingMs > 0
            ? new Date(pingMs).toLocaleTimeString("en-AU", { timeZone: "Australia/Melbourne", hour: "2-digit", minute: "2-digit" })
            : null;
          const speed = Number(record.speedKph ?? record.SpeedKph);
          const ignition = Number(record.ign ?? record.Ign);
          const hasStopEvidence = (Number.isFinite(speed) && speed < 3) || ignition === 0;

          byStopNo.forEach((geofence, stopNo) => {
            const inside = this.haversineMeters(lat, lng, geofence.lat, geofence.lng) <= geofence.radius;
            const key = String(stopNo);
            const previous = inFence.get(stopNo);
            if (inside) {
              if (!previous) inFence.set(stopNo, { enteredAt: timeLabel, hadStopEvidence: hasStopEvidence });
              else if (hasStopEvidence) previous.hadStopEvidence = true;
            } else if (previous) {
              if (previous.hadStopEvidence) {
                const stopState = progress.stopStates[key] || { status: "pending", enteredAt: null, exitedAt: null };
                progress.stopStates[key] = { ...stopState, status: "completed", enteredAt: previous.enteredAt || stopState.enteredAt || null, exitedAt: timeLabel };
                if (!progress.lastCompletedStopNo || stopNo > progress.lastCompletedStopNo) progress.lastCompletedStopNo = stopNo;
              }
              inFence.delete(stopNo);
            }
          });
        });

        let currentStopNo = null;
        inFence.forEach((active, stopNo) => {
          if (active.hadStopEvidence) currentStopNo = !currentStopNo || stopNo > currentStopNo ? stopNo : currentStopNo;
        });
        progress.currentStopNo = currentStopNo;
        if (currentStopNo) {
          const key = String(currentStopNo);
          const stopState = progress.stopStates[key] || { status: "pending", enteredAt: null, exitedAt: null };
          progress.stopStates[key] = { ...stopState, status: "current", enteredAt: stopState.enteredAt || inFence.get(currentStopNo).enteredAt || null };
        }
        progress.lastPingMs = Math.max(Number(progress.lastPingMs || 0), lastPingMs);
        progress.bootstrappedAt = Date.now();
        try { localStorage.setItem(this.getErpProgressKey(assetId), JSON.stringify(progress)); } catch (_) {}
        this.setState({ erpProgress: progress });
      } catch (error) {
        if (!(error && error.response && error.response.status === 404)) console.warn("ERP realtime progress history could not be loaded");
      } finally {
        delete this.erpProgressBootstrapRequests[requestKey];
      }
    })();
    this.erpProgressBootstrapRequests[requestKey] = request;
    return request;
  };

  updateErpProgressForSelectedAsset = () => {
    const asset = this.getSelectedAsset(this.getActiveAssets(this.state.realTimeData));
    if (!asset || !this.state.erpProgress || !this.state.erpGeofences.length) return;
    const gprmc = this.getGprmc(this.getLastMessage(asset));
    const lat = Number(this.getGprmcValue(gprmc, ["latitude", "Latitude", "lat", "Lat"]));
    const lng = Number(this.getGprmcValue(gprmc, ["longitude", "Longitude", "lng", "Lng", "lon", "Lon"]));
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;
    const message = this.getLastMessage(asset);
    const rawTime = this.getMessageValue(message, ["created", "Created", "createdTs", "CreatedTs", "dateTime", "DateTime"]);
    const parsedTime = rawTime ? new Date(rawTime).getTime() : Date.now();
    const pingMs = Number.isFinite(parsedTime) ? parsedTime : Date.now();
    const progress = { ...this.state.erpProgress, stopStates: { ...this.state.erpProgress.stopStates } };
    if (pingMs <= Number(progress.lastPingMs || 0)) return;
    let matched = null;
    this.state.erpGeofences.forEach((geofence) => {
      const distance = this.haversineMeters(lat, lng, Number(geofence.lat), Number(geofence.lng));
      const radius = Math.max(50, Number(geofence.radiusM) || 0);
      if (distance <= radius && (!matched || distance < matched.distance)) matched = { stopNo: Number(geofence.firstDrop), distance };
    });
    const nowLabel = new Date(pingMs).toLocaleTimeString("en-AU", { timeZone: "Australia/Melbourne", hour: "2-digit", minute: "2-digit" });
    const completeCurrent = () => {
      const current = Number(progress.currentStopNo || 0);
      if (!current) return;
      const state = progress.stopStates[String(current)] || { status: "pending" };
      if (state.status === "current") {
        progress.stopStates[String(current)] = { ...state, status: "completed", exitedAt: nowLabel };
        progress.lastCompletedStopNo = current;
      }
      progress.currentStopNo = null;
    };
    if (matched && matched.stopNo > 0) {
      if (Number(progress.currentStopNo || 0) !== matched.stopNo) completeCurrent();
      const key = String(matched.stopNo);
      const state = progress.stopStates[key] || { status: "pending", enteredAt: null, exitedAt: null };
      progress.currentStopNo = matched.stopNo;
      if (state.status !== "completed") progress.stopStates[key] = { ...state, status: "current", enteredAt: state.enteredAt || nowLabel };
    } else completeCurrent();
    progress.lastPingMs = pingMs;
    try { localStorage.setItem(this.getErpProgressKey(this.getAssetId(asset)), JSON.stringify(progress)); } catch (_) {}
    this.setState({ erpProgress: progress });
  };

  toggleErpGeofences = () => {
    const visible = !this.state.erpGeofencesVisible;
    localStorage.setItem("realTimeErpGeofencesVisible", visible ? "true" : "false");
    this.setState({ erpGeofencesVisible: visible });
  };

  setErpStopsPanelHidden = (hidden) => {
    localStorage.setItem("realTimeErpStopsPanelHidden", hidden ? "true" : "false");
    this.setState({ erpStopsPanelHidden: hidden });
  };

  renderErpStopsOverlay = () => {
    if (!this.state.erpOverlayAvailable || !this.state.selectedAssetId) return null;
    const stops = this.state.erpStops.slice().sort((a, b) => Number(a.dropNumber) - Number(b.dropNumber));
    if (!stops.length) return null;
    if (this.state.erpStopsPanelHidden) {
      return (
        <button type="button" className="erp-stops-show-button" onClick={() => this.setErpStopsPanelHidden(false)}>
          <i className="fa fa-list-ul"></i> Show stops
        </button>
      );
    }
    return (
      <div className="erp-stops-overlay">
        <div className="erp-stops-header">
          <div><strong>Today's stops</strong><span>{stops.length} deliveries</span></div>
          <div className="erp-stops-actions">
            <button type="button" className={this.state.erpGeofencesVisible ? "active" : ""} onClick={this.toggleErpGeofences}>
              <i className="fa fa-map-marker"></i> {this.state.erpGeofencesVisible ? "Hide geofences" : "Show geofences"}
            </button>
            <button type="button" onClick={() => this.setErpStopsPanelHidden(true)} title="Hide the stops panel">
              <i className="fa fa-minus"></i> Hide
            </button>
          </div>
        </div>
        <div className="erp-stops-list">
          {stops.map((stop) => {
            const status = (this.state.erpProgress && this.state.erpProgress.stopStates[String(stop.dropNumber)] && this.state.erpProgress.stopStates[String(stop.dropNumber)].status) || "pending";
            return <div className={`erp-stop-row ${status}`} key={stop.id || `${stop.dropNumber}-${stop.orderId}`}>
              <span className="erp-stop-dot">{status === "completed" ? <i className="fa fa-check"></i> : stop.dropNumber}</span>
              <span><strong>{stop.customerName || stop.customerCode || `Stop ${stop.dropNumber}`}</strong><small>{[stop.address1, stop.address2, stop.postcode].filter(Boolean).join(", ")}</small></span>
            </div>;
          })}
        </div>
      </div>
    );
  };

  getExistingAssetMetadata = (assetId) => {
    if (!assetId) return {};
    return this.currentList.find((asset) => String(this.getAssetId(asset)) === String(assetId)) || {};
  };

  normalizeRealtimeAssetMetadata = (asset) => {
    if (!asset) return asset;

    var assetId = this.getAssetId(asset);
    var existingAsset = this.getExistingAssetMetadata(assetId);
    var groupSettings = this.getSelectedGroupVisualSettings();
    var deviceType =
      this.getValue(asset, ["deviceType", "DeviceType"]) ||
      this.getValue(existingAsset, ["deviceType", "DeviceType"]) ||
      "";
    var canSetOdometerValue = this.getValue(asset, ["canSetOdometer", "CanSetOdometer"]);
    var existingCanSetOdometerValue = this.getValue(existingAsset, ["canSetOdometer", "CanSetOdometer"]);
    var hasIncomingDeviceType = !!this.getValue(asset, ["deviceType", "DeviceType"]);
    var canSetOdometer =
      canSetOdometerValue !== undefined && (canSetOdometerValue !== false || hasIncomingDeviceType || existingCanSetOdometerValue === undefined)
        ? canSetOdometerValue
        : existingCanSetOdometerValue;

    return {
      ...asset,
      assetId,
      deviceType,
      canSetOdometer,
      colour: this.getValue(asset, ["colour", "Colour", "color", "Color"]) || existingAsset.colour || existingAsset.Colour || "",
      icon: this.getValue(asset, ["icon", "Icon"]) || existingAsset.icon || existingAsset.Icon || "",
      groupColour: this.getValue(asset, ["groupColour", "GroupColour", "groupColor", "GroupColor"]) || existingAsset.groupColour || existingAsset.GroupColour || groupSettings.groupColour || "",
      groupIcon: this.getValue(asset, ["groupIcon", "GroupIcon"]) || existingAsset.groupIcon || existingAsset.GroupIcon || groupSettings.groupIcon || "",
    };
  };

  getAssetDeviceType = (asset) => {
    var message = this.getLastMessage(asset);
    return String(
      this.getValue(asset, ["deviceType", "DeviceType"]) ||
      this.getValue(message, ["deviceType", "DeviceType"]) ||
      ""
    ).trim().toUpperCase();
  };

  shouldShowDeviceVoltage = (asset) => this.getAssetDeviceType(asset) !== "MD101";

  canSetOdometerForAsset = (asset) => {
    var canSetOdometer = this.getValue(asset, ["canSetOdometer", "CanSetOdometer"]);
    if (canSetOdometer !== undefined) return canSetOdometer === true || canSetOdometer === "true" || canSetOdometer === 1;
    return this.getAssetDeviceType(asset) === "FOX3";
  };

  hasAssetSettings = (asset) => this.canSetOdometerForAsset(asset);

  getAssetSettingsSnapshot = (asset) => ({
    assetId: this.getAssetId(asset),
    canSetOdometer: this.canSetOdometerForAsset(asset),
  });

  getSelectedAssetSettings = (asset) => {
    var assetId = this.getAssetId(asset);
    var selectedSettings = this.state.selectedAssetSettings;
    if (selectedSettings && String(selectedSettings.assetId) === String(assetId)) {
      return selectedSettings;
    }
    return this.getAssetSettingsSnapshot(asset);
  };

  canSetOdometerForSelectedAsset = (asset) => {
    var settings = this.getSelectedAssetSettings(asset);
    return !!(settings && settings.canSetOdometer);
  };

  getAssetVisualColour = (asset) => {
    if (this.canUseUserAssetColourOverride()) {
      var overrideColour = this.getUserAssetColourOverride(asset);
      if (overrideColour) return overrideColour;
    }

    return this.getBaseAssetVisualColour(asset);
  };

  getBaseAssetVisualColour = (asset) => {
    return this.getValue(asset, ["colour", "Colour", "color", "Color"]) || this.getValue(asset, ["groupColour", "GroupColour", "groupColor", "GroupColor"]) || "";
  };

  getAssetVisualIcon = (asset) => {
    return this.getValue(asset, ["icon", "Icon"]) || this.getValue(asset, ["groupIcon", "GroupIcon"]) || (this.isDashcamAsset(asset) ? "fa fa-video-camera" : "fa fa-truck");
  };

  getRealtimeVisualModes = () => [
    {
      key: "default",
      title: "Custom truck colours",
      description: "Truck icon using asset or group colour",
    },
    {
      key: "ignition",
      title: "Ignition colours",
      description: "Truck icon with parked and driving colours",
    },
    {
      key: "custom",
      title: "Custom icons",
      description: "Use asset and group icons and colours",
    },
  ];

  getStatusVisualColour = (state) => {
    var colours = {
      driving: "#16a34a",
      parked: "#2563eb",
      offline: "#dc2626",
    };
    return colours[state] || colours.parked;
  };

  getAssetRealtimeListVisual = (asset) => {
    var mode = this.state.realtimeVisualMode;

    if (mode === "custom") {
      return {
        colour: this.getAssetVisualColour(asset) || DEFAULT_REALTIME_VISUAL_COLOUR,
        icon: this.getAssetVisualIcon(asset),
      };
    }

    return {
      colour: mode === "ignition" ? this.getStatusVisualColour(this.getAssetState(asset)) : this.getAssetVisualColour(asset) || DEFAULT_REALTIME_VISUAL_COLOUR,
      icon: "fa fa-truck",
      useOriginalTruck: true,
    };
  };

  renderOriginalTruckIcon = () => (
    <svg className="original-truck-icon" viewBox="0 0 48 48" aria-hidden="true" focusable="false">
      <path
        fill="currentColor"
        d="M14 7c9.99.1 20-.19 29.98.12 2.29-.06 3.73 2.01 4.02 4.07v23.55c-1.3.01-2.61.03-3.91.04-.87 2.96-2.73 6.24-6.24 6.27-3.86.47-6.52-2.87-7.26-6.29-4.06-.03-8.12-.01-12.19.03-.67 3.12-2.88 6.44-6.47 6.24-3.56.35-6.05-2.81-6.78-5.97-1.72-.08-3.43-.15-5.15-.2v-.73c1.54-3.11.97-6.6.98-9.93 2.17-2.91 4.35-5.82 6.56-8.7 2.15 0 4.3 0 6.45.01.01-2.84.01-5.67.01-8.51zM4.47 24c3.17.01 6.35-.01 9.53 0-.01-1.75-.01-3.49 0-5.24-1.79-.01-3.58-.02-5.37-.05-1.42 1.74-2.83 3.49-4.16 5.29zm4.99 8.55c-3 2.72 1.84 7.46 4.56 4.41 3.04-2.87-1.83-7.61-4.56-4.41zm25.76-.21c-3.16 2.43 1.11 7.48 4.06 4.87 3.48-2.38-1.06-7.94-4.06-4.87z"
      />
    </svg>
  );

  getSafeIconClass = (icon) => {
    var value = String(icon || "").trim();
    var iconKey = value.toLowerCase().replace(/^fa\s+/, "").replace(/^fa-/, "");
    var iconMap = {
      car: "fa fa-car",
      taxi: "fa fa-car",
      ute: "fa fa-truck",
      van: "fa fa-truck",
      trailer: "fa fa-truck",
      truck: "fa fa-truck",
      prime: "fa fa-truck",
      "prime-mover": "fa fa-truck",
      camera: "fa fa-video-camera",
      "video-camera": "fa fa-video-camera",
      plant: "fa fa-wrench",
      equipment: "fa fa-wrench",
      "plant-equipment": "fa fa-wrench",
      portable: "fa fa-briefcase",
      briefcase: "fa fa-briefcase",
    };

    if (!value) return "fa fa-truck";
    if (iconMap[iconKey]) return iconMap[iconKey];
    if (value.indexOf("fa-") === -1) return "fa fa-truck";
    return value.indexOf("fa ") === -1 ? `fa ${value}` : value;
  };

  getLastMessage = (asset) => {
    return this.getValue(asset, [
      "lastMessage",
      "LastMessage",
      "lastmessage",
      "message",
      "Message",
      "lastPing",
      "LastPing",
      "lastPingMessage",
      "LastPingMessage",
      "latestMessage",
      "LatestMessage",
    ]) || {};
  };

  getGprmc = (message) => {
    return this.getValue(message, ["gPRMC", "GPRMC", "gprmc", "gps", "GPS"]) || {};
  };

  getMessageValue = (message, keys) => {
    return this.getValue(message, keys);
  };

  getGprmcValue = (gprmc, keys) => {
    return this.getValue(gprmc, keys);
  };

  getMessageCreatedTimestamp = (message) => {
    var gprmc = this.getGprmc(message);
    return this.getValue(message, ["created", "Created"]) || this.getGprmcValue(gprmc, ["created", "Created"]);
  };

  getMessageTimestamp = (message) => {
    return this.getMessageCreatedTimestamp(message);
  };

  getMessageId = (message) => {
    return this.getMessageValue(message, ["messageID", "MessageID", "messageId", "MessageId"]);
  };

  getMessageIdDisplay = (message) => {
    var messageId = this.getMessageId(message);
    var description = this.getMessageValue(message, ["messageName", "MessageName", "messageDescription", "MessageDescription"]);
    if (messageId === undefined || messageId === null || messageId === "") return "";
    return description ? `${messageId} – ${String(description).trim()}` : messageId;
  };

  getGpsValidity = (message) => {
    var gprmc = this.getGprmc(message);
    return this.getGprmcValue(gprmc, ["validity", "Validity", "valid", "Valid", "gpsValidity", "GPSValidity"]);
  };

  isGpsLocked = (message) => {
    var validity = this.getGpsValidity(message);
    if (validity === true || validity === 1) return true;
    if (validity === false || validity === 0 || validity === null || validity === undefined) return false;
    return String(validity).trim().toUpperCase() === "A";
  };

  getTimestampTitle = (message) => {
    var created = utcToReportDate(this.getMessageCreatedTimestamp(message)) || "-";
    var messageId = this.getMessageId(message) || "-";
    return `Created: ${created}, MessageID: ${messageId}`;
  };

  getMessageAssetId = (message, asset) => {
    return this.getValue(message, ["assetID", "assetId", "AssetID", "AssetId"]) || this.getValue(asset, ["assetId", "AssetId", "id", "Id"]);
  };

  isTruthyFlag = (value) => {
    if (value === true || value === 1) return true;
    if (value === false || value === 0 || value === null || value === undefined) return false;
    return ["1", "true", "yes", "y"].indexOf(String(value).toLowerCase()) !== -1;
  };

  getLocation = (data) => {
    var lastMessage = this.getLastMessage(data);
    var gprmc = this.getGprmc(lastMessage);
    var latitude = this.getGprmcValue(gprmc, ["latitude", "Latitude", "lat", "Lat"]);
    var longitude = this.getGprmcValue(gprmc, ["longitude", "Longitude", "lng", "Lng", "lon", "Lon"]);
    if (!lastMessage || !latitude || !longitude) return null;

    return {
      assetId: this.getMessageAssetId(lastMessage, data),
      created: this.getValue(lastMessage, ["created", "Created"]),
      address: this.getValue(lastMessage, ["location", "Location", "address", "Address"]),
      lat: latitude,
      lng: longitude,
      speed: this.getGprmcValue(gprmc, ["speed", "Speed"]),
      odometer: this.getMessageValue(lastMessage, ["odometer", "Odometer"]),
      name: data.assetName,
      tempA: this.getMessageValue(lastMessage, ["sensorAValue", "SensorAValue"]),
      tempB: this.getMessageValue(lastMessage, ["sensorBValue", "SensorBValue"]),
      fridge: this.getMessageValue(lastMessage, ["iO1", "IO1", "io1"]) == 1 ? "On" : "Off",
      gprs: this.getMessageValue(lastMessage, ["gprsOnline", "GprsOnline", "GPRSOnline", "gprs"]),
      heading: this.getGprmcValue(gprmc, ["heading", "Heading"]),
      parking: this.getMessageValue(lastMessage, ["iO3", "IO3", "io3"]),
      trip: this.getMessageValue(lastMessage, ["tripCount", "TripCount"]),
      duress: data.lastDuress || "",
      volt: this.getMessageValue(lastMessage, ["deviceVolts", "DeviceVolts"]),
      satelite: this.getMessageValue(lastMessage, ["satellites", "Satellites"]),
      lastUpdated: this.getMessageTimestamp(lastMessage),
      friendlyName: data.friendlyName,
      colour: this.getAssetVisualColour(data),
      icon: this.getAssetVisualIcon(data),
      lastDuress: data.lastDuress || "",
      lastPowerCut: data.lastPowerCut || "",
      lastStatusChange: data.lastStatusChange || "",
    };
  };

  loadVideoUsageAvailability = async () => {
    if (!canAccessVideo()) return;
    try {
      const response = await axios.get(`${apiHost}/api/Video/Usage/Availability`, { headers: this.getAuthHeaders() });
      if (this.realtimeMounted) this.setState({ hasVideoUsage: response.data.hasUsage === true });
    } catch (_) { /* Keep the shortcut hidden until usage history is confirmed. */ }
  };

  queueVideoCameraStatusRefresh = () => {
    const assetKey = this.getActiveAssets(this.state.realTimeData).filter(this.isDashcamAsset).map(asset => String(this.getAssetId(asset))).sort().join(",");
    if (assetKey === this.videoStatusAssetKey) return;
    this.videoStatusAssetKey = assetKey;
    clearTimeout(this.videoStatusRefreshTimer);
    this.videoStatusRefreshTimer = setTimeout(this.refreshVideoCameraStatuses, 250);
  };

  refreshVideoCameraStatuses = async () => {
    if (!this.realtimeMounted || !canAccessVideo() || document.hidden || this.videoStatusLoading) return;
    const ids = [...new Set(this.getActiveAssets(this.state.realTimeData).filter(this.isDashcamAsset).map(asset => String(this.getAssetId(asset))))];
    if (!ids.length) return;
    this.videoStatusLoading = true;
    // Re-render on return from a hidden tab so expired green status disappears immediately.
    this.setState(previous => ({ videoCameraStatuses: Object.fromEntries(Object.entries(previous.videoCameraStatuses)
      .filter(([, value]) => Date.now() - value.checkedAt < 45000)) }));
    try {
      for (let i = 0; i < ids.length && this.realtimeMounted && !document.hidden; i += 100) {
        const batch = ids.slice(i, i + 100);
        let statuses = {};
        try {
          const response = await axios.post(`${apiHost}/api/Video/CameraStatus`, batch, { headers: this.getAuthHeaders(), timeout: 30000 });
          batch.forEach(id => { statuses[id] = { status: "unknown", checkedAt: Date.now() }; });
          if (Array.isArray(response.data)) response.data.forEach(row => {
            if (batch.includes(String(row.assetId))) statuses[String(row.assetId)] = { status: row.status, checkedAt: Date.now() };
          });
        } catch (_) {
          batch.forEach(id => { statuses[id] = { status: "unknown", checkedAt: Date.now() }; });
        }
        if (this.realtimeMounted) this.setState(previous => ({ videoCameraStatuses: { ...previous.videoCameraStatuses, ...statuses } }));
      }
    } finally { this.videoStatusLoading = false; }
  };

  getVideoCameraStatus = asset => {
    const result = this.state.videoCameraStatuses[String(this.getAssetId(asset))];
    return result && Date.now() - result.checkedAt < 45000 && ["online", "offline"].includes(result.status) ? result.status : "unknown";
  };

  getAssetState = (asset) => {
    var lastMessage = this.getLastMessage(asset);
    var gprsOnline = this.getValue(lastMessage, ["gprsOnline", "GprsOnline", "GPRSOnline", "gprs"]);
    var engineOn = this.getValue(lastMessage, ["iO3", "IO3", "io3"]);
    if (!lastMessage || gprsOnline != 1) return "offline";
    return engineOn == 1 ? "driving" : "parked";
  };

  getAssetStatusClass = (asset) => {
    var rawStatus = asset ? (asset.statusString || asset.status) : "";
    var status = String(rawStatus || "").trim().toLowerCase();
    if (status === "active") return "asset-status-active";
    if (status === "maintenance") return "asset-status-maintenance";
    return "";
  };

  normalizeDriverAssetEvent = (event) => {
    if (!event) return null;

    var driverName = this.getValue(event, ["driverName", "DriverName"]);
    var eventLabel = this.getValue(event, ["eventLabel", "EventLabel"]);
    var eventType = this.getValue(event, ["eventType", "EventType"]);
    var occurredAt = this.getValue(event, ["occurredAt", "OccurredAt"]);
    var hasDefects = this.getValue(event, ["hasDefects", "HasDefects"]);
    var recordKind = this.getValue(event, ["recordKind", "RecordKind"]);
    var runId = this.getValue(event, ["runId", "RunId"]);
    var testMode = this.getValue(event, ["testMode", "TestMode"]);
    var isAutoLogoutValue = this.getValue(event, ["isAutoLogout", "IsAutoLogout"]);
    var isAutoLogout = isAutoLogoutValue === true || Number(isAutoLogoutValue) === 1;

    if (!driverName || !occurredAt) return null;

    return {
      driverName,
      eventType,
      eventLabel: isAutoLogout ? "Auto Logout" : eventLabel || (eventType === "pre_start" ? "Start of Shift" : eventType === "post_trip" ? "End of Shift" : "Driver Event"),
      occurredAt,
      hasDefects: hasDefects === true || Number(hasDefects) === 1,
      recordKind: recordKind || "event",
      runId: runId == null ? null : Number(runId),
      testMode: testMode === true || Number(testMode) === 1,
      isAutoLogout,
    };
  };

  openCriticalFailure = async () => {
    const event = this.state.driverAssetEvent;
    const assetId = this.state.selectedAssetId;
    if (!event || !event.hasDefects || event.recordKind !== "checklist" || !event.runId || !assetId) return;
    this.setState({ criticalFailureModalOpen: true, criticalFailureLoading: true, criticalFailureError: "", criticalFailureDetails: null });
    try {
      const response = await axios.get(`${apiHost}/api/Assets/${assetId}/CriticalChecklistFailures/${event.runId}`, {
        params: { test: !!event.testMode }, headers: this.getAuthHeaders(),
      });
      this.setState({ criticalFailureLoading: false, criticalFailureDetails: response.data });
    } catch (error) {
      if (error && error.response && error.response.status === 401) this.props.history.push("/login");
      const message = error && error.response && error.response.data && error.response.data.message;
      this.setState({ criticalFailureLoading: false, criticalFailureError: message || "Unable to load the critical checklist details." });
    }
  };

  closeCriticalFailure = () => this.setState({ criticalFailureModalOpen: false, criticalFailureLoading: false, criticalFailureError: "", criticalFailureDetails: null });

  criticalFailureModalType = () => {
    const details = this.state.criticalFailureDetails || {};
    const event = this.state.driverAssetEvent || {};
    const runType = details.runType || details.RunType || event.eventType || event.EventType || event.checklistType || event.ChecklistType || event.runType || event.RunType;
    return runType === "pre_start" ? "pre-start" : "post-trip";
  };

  renderCriticalFailureDetails = () => {
    const details = this.state.criticalFailureDetails;
    if (this.state.criticalFailureLoading) return <div className="critical-failure-state" role="status"><i className="fa fa-spinner fa-spin" aria-hidden="true"></i> Loading failure details…</div>;
    if (this.state.criticalFailureError) return <div className="critical-failure-state error" role="alert">{this.state.criticalFailureError}<button type="button" onClick={this.openCriticalFailure}>Try again</button></div>;
    if (!details) return null;
    const get = (object, camel, pascal) => object && (object[camel] != null ? object[camel] : object[pascal]);
    const failures = get(details, "failedResponses", "FailedResponses") || [];
    const assetName = [get(details, "assetName", "AssetName"), get(details, "assetFriendlyName", "AssetFriendlyName")].filter(Boolean).join(" — ");
    const runType = get(details, "runType", "RunType");
    return <div className={`critical-failure-details ${runType === "pre_start" ? "pre-start" : "post-trip"}`}>
      <div className="critical-failure-summary">
        <div><span>Run type</span><strong>{runType === "pre_start" ? "Pre-Start" : "Post-Trip"}</strong></div>
        <div><span>Driver</span><strong>{get(details, "driverName", "DriverName") || "—"}</strong></div>
        <div><span>Asset</span><strong>{assetName || "—"}</strong></div>
        <div><span>Completed</span><strong>{utcToDriverEventDate(get(details, "completedAt", "CompletedAt")) || "—"}</strong></div>
      </div>
      <div className="critical-failure-list">
        {failures.map((failure, index) => {
          const attachments = get(failure, "attachments", "Attachments") || [];
          return <article key={get(failure, "responseId", "ResponseId") || index}>
            <div className="critical-failure-question"><i className="fa fa-exclamation-triangle" aria-hidden="true"></i><strong>{get(failure, "question", "Question")}</strong></div>
            <dl><dt>Response</dt><dd>{get(failure, "response", "Response") || "—"}</dd><dt>Notes</dt><dd>{get(failure, "notes", "Notes") || "No notes provided"}</dd></dl>
            {!!attachments.length && <section className="critical-failure-photos" aria-label="Failure photos"><h4>Photos</h4><div className="critical-failure-gallery">{attachments.map((attachment, photoIndex) => {
              const url = get(attachment, "thumbnailUrl", "ThumbnailUrl") || get(attachment, "url", "Url");
              return <a key={get(attachment, "id", "Id") || photoIndex} href={get(attachment, "url", "Url")} target="_blank" rel="noopener noreferrer"><img src={url} alt={get(attachment, "fileName", "FileName") || `Critical failure photo ${photoIndex + 1}`} /></a>;
            })}</div></section>}
          </article>;
        })}
      </div>
    </div>;
  };

  stopDriverEventPolling = () => {
    if (this.driverEventPollTimer) {
      clearInterval(this.driverEventPollTimer);
      this.driverEventPollTimer = null;
    }
    this.driverEventRequestId += 1;
  };

  startDriverEventPolling = (assetId) => {
    this.stopDriverEventPolling();
    this.incidentSummaryRequest = (this.incidentSummaryRequest || 0) + 1;
    this.setState({ driverIncidents: [], driverIncidentsHasMore: false, driverIncidentsFailed: false });

    if (!assetId) {
      this.setState({ driverAssetEvent: null, driverAssetEventAssetId: "", latestDriverIncident: null, modalDriverIncident: null, incidentAcknowledgementPending: null, incidentActionMessage: "", incidentModalOpen: false });
      return;
    }

    this.setState({ latestDriverIncident: null, modalDriverIncident: null, incidentAcknowledgementPending: null, incidentActionMessage: "", incidentModalOpen: false });
    this.loadLatestDriverEvent(assetId);
    this.loadLatestDriverIncident(assetId);
    this.driverEventPollTimer = setInterval(() => {
      if (!document.hidden) {
        this.loadLatestDriverEvent(assetId, true);
        this.loadLatestDriverIncident(assetId);
      }
    }, DRIVER_EVENT_POLL_INTERVAL_MS);
  };

  loadLatestDriverEvent = async (assetId, silent) => {
    if (!assetId) return;

    var requestId = ++this.driverEventRequestId;
    try {
      var response = await axios.get(`${apiHost}/api/Assets/${assetId}/LatestDriverEvent`, {
        headers: this.getAuthHeaders(),
      });

      if (requestId !== this.driverEventRequestId || String(assetId) !== String(this.state.selectedAssetId)) return;

      this.setState({
        driverAssetEvent: this.normalizeDriverAssetEvent(response.data),
        driverAssetEventAssetId: assetId,
      });
    } catch (e) {
      if (e && e.response && e.response.status == "401") {
        this.props.history.push("/login");
      }

      if (!silent && String(assetId) === String(this.state.selectedAssetId)) {
        this.setState({
          driverAssetEvent: null,
          driverAssetEventAssetId: assetId,
        });
      }
    }
  };

  handleIncidentChange = event => {
    if (event.type === "storage" && event.key !== "driver-incidents-changed") return;
    if (this.state.selectedAssetId) this.loadLatestDriverIncident(this.state.selectedAssetId);
  };

  notifyIncidentChange = () => {
    window.dispatchEvent(new Event("driver-incidents-changed"));
    try { localStorage.setItem("driver-incidents-changed", `${Date.now()}-${Math.random()}`); } catch (_) {}
  };

  loadLatestDriverIncident = async (assetId, more = false) => {
    const request = this.incidentSummaryRequest = (this.incidentSummaryRequest || 0) + 1;
    const offset = more ? this.state.driverIncidents.length : 0;
    const current = () => this.realtimeMounted && request === this.incidentSummaryRequest && String(assetId) === String(this.state.selectedAssetId);
    try {
      const response = await axios.get(`${apiHost}/api/Assets/RecentDriverIncidents?assetId=${encodeURIComponent(assetId)}&realtime=true&offset=${offset}`, { headers: this.getAuthHeaders(), timeout: 20000 });
      if (!current()) return;
      if (!Array.isArray(response.data?.items)) throw new Error("Invalid incident summaries");
      const rows = response.data.items.map(i => ({ ...i, id: i.incidentId, reference: i.incidentReference }));
      const items = offset ? [...this.state.driverIncidents, ...rows].filter((i, index, all) => all.findIndex(other => String(other.id) === String(i.id)) === index) : rows;
      this.setState({ driverIncidents: items, latestDriverIncident: items[0] || null, driverIncidentsHasMore: response.data.hasMore, driverIncidentsFailed: false });
      // Keep the explicit modal fresh even when an old incident leaves the awareness list.
      const modal = this.state.modalDriverIncident;
      if (this.state.incidentModalOpen && modal && !this.state.incidentAcknowledgementSaving) {
        const detail = await axios.get(`${apiHost}/api/Assets/${assetId}/DriverIncidents/${modal.id}`, { headers: this.getAuthHeaders(), timeout: 20000 });
        if (current() && detail.data && String(this.state.modalDriverIncident?.id) === String(modal.id) && !this.state.incidentAcknowledgementSaving)
          this.setState({ modalDriverIncident: { ...detail.data, photos: modal.photos || [] }, ...(detail.data.acknowledgedAt ? { incidentAcknowledgementPending: null } : {}) });
      }
    } catch (_) {
      if (current()) this.setState({ driverIncidentsFailed: true });
    }
  };

  openDriverIncident = async incident => {
    this.incidentLinkRequest = (this.incidentLinkRequest || 0) + 1;
    const assetId = this.state.selectedAssetId;
    const request = this.incidentDetailRequest = (this.incidentDetailRequest || 0) + 1;
    this.setState({ incidentActionMessage: "", incidentAcknowledgementPending: null });
    try {
      const response = await axios.get(`${apiHost}/api/Assets/${assetId}/DriverIncidents/${incident.id}`, { headers: this.getAuthHeaders() });
      if (!response.data) throw new Error("Incident unavailable");
      const photos = await axios.get(`${apiHost}/api/Assets/${assetId}/DriverIncidents/${incident.id}/Photos`, { headers: this.getAuthHeaders() });
      if (this.realtimeMounted && request === this.incidentDetailRequest && String(assetId) === String(this.state.selectedAssetId))
        this.setState({ modalDriverIncident: { ...response.data, photos: photos.data || [] }, incidentModalOpen: true });
    } catch (_) {
      if (this.realtimeMounted && request === this.incidentDetailRequest && String(assetId) === String(this.state.selectedAssetId))
        this.setState({ incidentActionMessage: "Unable to open this incident. Please try again." });
    }
  };

  acknowledgeDriverIncident = async () => {
    const incident = this.state.incidentAcknowledgementPending;
    const assetId = this.state.selectedAssetId;
    if (!incident || !assetId || this.state.incidentAcknowledgementSaving) return;
    this.incidentSummaryRequest = (this.incidentSummaryRequest || 0) + 1;
    this.setState({ incidentAcknowledgementSaving: true, incidentActionMessage: "" });
    try {
      const response = await axios.post(`${apiHost}/api/Assets/${assetId}/DriverIncidents/${incident.id}/Acknowledge`, { acceptResponsibility: true }, { headers: this.getAuthHeaders() });
      if (!response.data?.acknowledgedAt) throw new Error("Invalid acknowledgement response");
      if (this.realtimeMounted && String(assetId) === String(this.state.selectedAssetId) && String(this.state.modalDriverIncident?.id) === String(incident.id)) {
        const acknowledgement = response.data;
        this.setState({ modalDriverIncident: { ...this.state.modalDriverIncident, ...acknowledgement }, incidentAcknowledgementPending: null,
          incidentActionMessage: `${acknowledgement.alreadyAcknowledged ? "Already acknowledged" : "Acknowledged"} by ${acknowledgement.acknowledgedByName || acknowledgement.acknowledgedById} at ${utcToDriverEventDate(acknowledgement.acknowledgedAt)}. Follow-up has been recorded; this does not mark the incident resolved.` });
      }
      this.notifyIncidentChange();
    } catch (_) {
      if (this.realtimeMounted) this.setState({ incidentActionMessage: "Unable to confirm acknowledgement. Please retry; the first recorded acknowledgement will be preserved." });
    } finally {
      if (this.realtimeMounted) this.setState({ incidentAcknowledgementSaving: false });
    }
  };

  hideDriverIncident = async incident => {
    if (!incident.acknowledgedAt) return;
    const assetId = this.state.selectedAssetId;
    try {
      await axios.post(`${apiHost}/api/Assets/${assetId}/DriverIncidents/${incident.id}/Hide`, {}, { headers: this.getAuthHeaders() });
      this.notifyIncidentChange();
    } catch (_) {
      if (this.realtimeMounted) this.setState({ incidentActionMessage: "Unable to hide this incident. Only acknowledged incidents can be hidden." });
    }
  };

  renderIncidentAlertCard = (extraClassName = "") => <div className={`realtime-incident-list ${extraClassName}`}>
    {this.state.driverIncidentsFailed && <p role="status">Unable to refresh incidents. Showing the last available result.</p>}
    {this.state.driverIncidents.map(i => <section key={i.id} className={`ping-card realtime-incident-alert ${i.acknowledgedAt ? "acknowledged" : "unacknowledged"}`}>
      <button type="button" className="realtime-incident-open" onClick={() => this.openDriverIncident(i)}>
        <i className={`fa ${i.acknowledgedAt ? "fa-check-circle" : "fa-exclamation-triangle"}`} aria-hidden="true" />
        <span><span>{i.acknowledgedAt ? "Acknowledged" : "Awaiting acknowledgement"}</span><strong>{i.reference}</strong>
          <small>{String(i.incidentType || "").replace(/_/g, " ")} — {i.driverName}</small>
        </span>
      </button>
      {i.acknowledgedAt && <button type="button" className="realtime-incident-hide" onClick={() => this.hideDriverIncident(i)} title="Hide this acknowledged tile for my account only" aria-label={`Hide acknowledged incident ${i.reference} for my account`}>×</button>}
    </section>)}
    {this.state.driverIncidentsHasMore && <button type="button" onClick={() => this.loadLatestDriverIncident(this.state.selectedAssetId, true)}>Load more incidents</button>}
  </div>;

  renderIncidentAcknowledgement = incident => <section className={`incident-responsibility ${incident.acknowledgedAt ? "acknowledged" : ""}`}>
    {this.state.incidentActionMessage && <p role="status">{this.state.incidentActionMessage}</p>}
    {incident.acknowledgedAt ? <div className="incident-acknowledgement-record">
      <div className="incident-acknowledgement-status"><i className="fa fa-check-circle" aria-hidden="true" /><strong>Acknowledged</strong></div>
      <div className="incident-acknowledgement-meta"><span>By</span><strong>{incident.acknowledgedByName || incident.acknowledgedById}</strong><span aria-hidden="true">·</span><time>{utcToDriverEventDate(incident.acknowledgedAt)}</time></div>
      <div className="incident-acknowledgement-note">{incident.acknowledgementStatement ? "Follow-up has been acknowledged. Other users can see that this incident is being actioned." : "This acknowledgement was recorded before follow-up confirmation was introduced. It does not mark the incident resolved."}</div>
    </div>
      : <>
        <h4>What does acknowledgement mean?</h4>
        <p>Acknowledging an incident lets other users know that someone is following it up.</p>
        <p>The person acknowledging the incident should contact the driver and check on their welfare.</p>
        <p>Your name and the acknowledgement time will be recorded. Acknowledging the incident does not mean the driver has been confirmed safe or that the incident has been resolved.</p>
        <div className="incident-responsibility-actions">
          <button type="button" onClick={() => this.setState({ incidentModalOpen: false, modalDriverIncident: null, incidentAcknowledgementPending: null })}>Cancel</button>
          <button type="button" onClick={() => this.setState({ incidentAcknowledgementPending: incident, incidentActionMessage: "" })}>Acknowledge incident</button>
        </div></>}
  </section>;

  incidentResponseIsCritical = (label,value) => (label === "Vehicle safe to continue" && value === "no") || (["Dangerous goods","Fatigue possible factor","Towing / recovery required"].includes(label) && value === "yes");
  renderIncidentDetails = () => { const i=this.state.modalDriverIncident || this.state.latestDriverIncident;if(!i)return null; const rows=[["Reference",i.reference],["Driver",i.driverName],["Asset",[i.assetName,i.assetFriendlyName].filter(Boolean).join(" — ")],["Incident type",String(i.incidentType||"").replace(/_/g," ")],["Occurred",utcToDriverEventDate(i.occurredAt)],["Location",i.location||([i.latitude,i.longitude].filter(v=>v!=null).join(", "))],["What happened",i.description],["Injury",i.injuryInvolved],["Injury details",i.injuryDetails],["Other vehicle",i.otherVehicleInvolved],["Other driver",i.otherDriverName],["Other phone",i.otherDriverPhone],["Other registration",i.otherVehicleRegistration],["Other vehicle",i.otherVehicleMakeModel],["Insurer",i.insurer],["Property damage",i.propertyDamage],["Property details",i.propertyDamageDetails],["Police attended",i.policeAttended],["Alcohol PBT",i.policeAlcoholTest],["Drug screening POFT",i.policeDrugTest],["Police reference",i.policeReference],["Required licence class",i.assetRequiredLicenceClass],["Carrying load",i.carryingLoad],["Load affected",i.loadAffected],["Load details",i.loadDetails],["Dangerous goods",i.dangerousGoodsInvolved],["Dangerous goods details",i.dangerousGoodsDetails],["Fatigue possible factor",i.fatiguePossibleFactor],["Vehicle safe to continue",i.vehicleSafeToContinue],["Towing / recovery required",i.towingRecoveryRequired],["Towing / recovery details",i.towingRecoveryDetails],["Post-incident testing required",i.postIncidentTestingRequired],["Post-incident testing status",i.postIncidentTestingStatus],["Post-incident testing details",i.postIncidentTestingDetails],["Odometer",i.odometer],["Declaration",i.driverDeclared?"Confirmed":"Not confirmed"]]; return <div className="realtime-incident-details"><dl>{rows.filter(r=>r[1]!==null&&r[1]!==undefined&&r[1]!=="").map(([label,value])=><React.Fragment key={label}><dt>{label}</dt><dd className={this.incidentResponseIsCritical(label,value)?"incident-critical-response":""}>{String(value)}</dd></React.Fragment>)}</dl>{!!(i.photos||[]).length&&<section className="realtime-incident-photos"><h4>Photos</h4><div>{i.photos.map(photo=><a key={photo.id} href={photo.url} target="_blank" rel="noopener noreferrer"><img src={photo.thumbnailUrl||photo.url} alt={photo.fileName||"Incident evidence"}/></a>)}</div></section>}{this.renderIncidentAcknowledgement(i)}</div>; };

  renderDriverStatusCard = (asset, extraClassName = "") => {
    var driverEvent = this.state.driverAssetEvent;
    if (!driverEvent || String(this.state.driverAssetEventAssetId) !== String(this.getAssetId(asset))) return null;

    var eventTime = utcToDriverEventDate(driverEvent.occurredAt);
    var eventClassName = driverEvent.isAutoLogout
      ? "auto-logout"
      : driverEvent.eventType === "pre_start"
      ? "start-of-shift"
      : driverEvent.eventType === "post_trip" ? "end-of-shift" : "unknown-shift";
    var cardClassName = [
      "ping-card",
      "driver-status-card",
      eventClassName,
      driverEvent.hasDefects ? "critical-checklist-failure" : "",
      extraClassName,
    ].filter(Boolean).join(" ");

    return (
      <section className={cardClassName} role={driverEvent.hasDefects ? "button" : undefined} tabIndex={driverEvent.hasDefects ? 0 : undefined}
        aria-label={driverEvent.hasDefects ? "Open critical checklist failure details" : undefined}
        onClick={driverEvent.hasDefects ? this.openCriticalFailure : undefined}
        onKeyDown={driverEvent.hasDefects ? (event => { if (event.key === "Enter" || event.key === " ") { event.preventDefault(); this.openCriticalFailure(); } }) : undefined}>
        <div className="driver-status-icon" aria-hidden="true">
          <i className="fa fa-id-card-o"></i>
        </div>
        <div className="driver-status-content">
          <span>Driver</span>
          <strong>{driverEvent.driverName}</strong>
        </div>
        <div className="driver-status-event">
          <span>{driverEvent.eventLabel}</span>
          {driverEvent.hasDefects && <em><i className="fa fa-exclamation-triangle" aria-hidden="true"></i> Critical checklist failure</em>}
          <strong>{eventTime || "-"}</strong>
        </div>
      </section>
    );
  };

  getPingHealth = (asset) => {
    var lastMessage = this.getLastMessage(asset);
    var lastPing = this.getMessageTimestamp(lastMessage);
    if (!lastPing) return "stale";

    var pingDate = new Date(lastPing);
    if (isNaN(pingDate.getTime())) return "stale";

    var hoursOld = (Date.now() - pingDate.getTime()) / 1000 / 60 / 60;
    if (hoursOld < 2) return "fresh";
    if (hoursOld < 24) return "aging";
    return "stale";
  };

  getSelectedAsset = (assets) => {
    if (!assets.length || !this.state.selectedAssetId) return null;
    return assets.find((asset) => String(asset.assetId) === String(this.state.selectedAssetId)) || null;
  };

  getActiveAssets = (assets) => {
    return assets
      .filter((asset) => asset.status !== "Disabled")
      .sort((a, b) => (a.assetName || "").localeCompare(b.assetName || ""));
  };

  getAddressKey = (asset) => {
    var gprmc = this.getGprmc(this.getLastMessage(asset));
    var latitude = this.getGprmcValue(gprmc, ["latitude", "Latitude", "lat", "Lat"]);
    var longitude = this.getGprmcValue(gprmc, ["longitude", "Longitude", "lng", "Lng", "lon", "Lon"]);
    if (!gprmc || !latitude || !longitude) return "";
    return `${parseFloat(latitude).toFixed(6)},${parseFloat(longitude).toFixed(6)}`;
  };

  getMessageAddress = (message) => {
    return this.getValue(message, ["location", "Location", "address", "Address"]);
  };

  isSystemAdmin = () => {
    return localStorage.getItem("role") === "SystemAdmin";
  };

  getListAddress = (asset) => {
    var lastMessage = this.getLastMessage(asset);
    var payloadAddress = this.getMessageAddress(lastMessage);
    if (payloadAddress) return payloadAddress;
    if (!ENABLE_REALTIME_LIST_ADDRESS_LOOKUP) return "";

    var addressKey = this.getAddressKey(asset);
    return addressKey ? this.state.listAddresses[addressKey] : "";
  };

  getListAddressSource = (asset) => {
    var addressKey = this.getAddressKey(asset);
    return addressKey ? this.state.listAddressSources[addressKey] : "";
  };

  shouldShowAddressSourceIndicators = () => {
    return this.isSystemAdmin() && this.state.showAddressSourceIndicators;
  };

  isHereAddressSource = (source) => {
    return source === "here";
  };

  getAddressSourceLabel = (source) => {
    switch (source) {
      case "here":
        return "Address returned from HERE Maps";
      case "browser-cache":
        return "Address returned from browser cache";
      case "memory-cache":
        return "Address returned from backend memory cache";
      case "db-cache":
        return "Address returned from backend address table";
      case "cache":
        return "Address returned from cache";
      default:
        return "Address source unknown";
    }
  };

  queueListAddressBatch = (assets) => {
    if (!ENABLE_REALTIME_LIST_ADDRESS_LOOKUP) return;

    var missingLocations = [];
    var seen = {};

    assets.forEach((asset) => {
      var lastMessage = this.getLastMessage(asset);
      if (this.getMessageAddress(lastMessage)) return;

      var gprmc = this.getGprmc(lastMessage);
      var latitude = this.getGprmcValue(gprmc, ["latitude", "Latitude", "lat", "Lat"]);
      var longitude = this.getGprmcValue(gprmc, ["longitude", "Longitude", "lng", "Lng", "lon", "Lon"]);
      var key = this.getAddressKey(asset);

      if (!key || seen[key] || (this.state.listAddresses[key] && !this.state.bypassBrowserAddressCache && !this.state.forceHereAddressLookup)) return;
      seen[key] = true;
      missingLocations.push({ key, latitude, longitude });
    });

    var batchKey = missingLocations.map((location) => location.key).join("|");
    if (batchKey === this.state.listAddressBatchKey) return;

    if (this.listAddressTimer) {
      clearTimeout(this.listAddressTimer);
      this.listAddressTimer = null;
    }

    this.setState({ listAddressBatchKey: batchKey });
    if (!missingLocations.length) return;

    var requestId = ++this.listAddressRequestId;
    this.listAddressTimer = setTimeout(() => {
      this.processListAddressBatch(missingLocations, batchKey, requestId);
    }, 350);
  };

  processListAddressBatch = async (locations, batchKey, requestId) => {
    var chunkSize = 40;

    for (var index = 0; index < locations.length; index += chunkSize) {
      if (requestId !== this.listAddressRequestId) return;

      var chunk = locations.slice(index, index + chunkSize);
      var results = await Promise.all(chunk.map((location) =>
        locationCache.getAddressDetails(location.latitude, location.longitude, {
          bypassCache: this.state.bypassBrowserAddressCache,
          forceRefresh: this.state.forceHereAddressLookup,
        })
      ));
      var chunkAddresses = {};
      var chunkSources = {};

      for (var resultIndex = 0; resultIndex < results.length; resultIndex++) {
        var result = results[resultIndex] || {};
        var address = result.address || "";
        if (address) {
          chunkAddresses[chunk[resultIndex].key] = address;
          chunkSources[chunk[resultIndex].key] = result.source || "";
        }
      }

      if (Object.keys(chunkAddresses).length && this.state.listAddressBatchKey === batchKey) {
        this.setState({
          listAddresses: { ...this.state.listAddresses, ...chunkAddresses },
          listAddressSources: { ...this.state.listAddressSources, ...chunkSources },
        });
      }
    }
  };

  resetAddressDiagnostics = () => {
    this.listAddressRequestId += 1;
    if (this.listAddressTimer) {
      clearTimeout(this.listAddressTimer);
      this.listAddressTimer = null;
    }
    locationCache.clearCache();
    this.setState({
      listAddresses: {},
      listAddressSources: {},
      listAddressBatchKey: "",
      selectedAddress: "",
      selectedAddressKey: "",
      selectedAddressLoading: false,
    });
  };

  toggleDevPanel = () => {
    this.setState({ devPanelOpen: !this.state.devPanelOpen });
  };

  openUserSettings = () => {
    this.setState({ userSettingsOpen: true });
  };

  closeUserSettings = () => {
    this.setState({ userSettingsOpen: false });
  };

  toggleAddressSourceIndicators = () => {
    var showAddressSourceIndicators = !this.state.showAddressSourceIndicators;
    localStorage.setItem("realTimeShowAddressSourceIndicators", showAddressSourceIndicators ? "true" : "false");
    this.setState({ showAddressSourceIndicators });
  };

  toggleBypassBrowserAddressCache = () => {
    var bypassBrowserAddressCache = !this.state.bypassBrowserAddressCache;
    localStorage.setItem("realTimeBypassBrowserAddressCache", bypassBrowserAddressCache ? "true" : "false");
    this.setState({ bypassBrowserAddressCache }, this.resetAddressDiagnostics);
  };

  toggleForceHereAddressLookup = () => {
    var forceHereAddressLookup = !this.state.forceHereAddressLookup;
    localStorage.setItem("realTimeForceHereAddressLookup", forceHereAddressLookup ? "true" : "false");
    this.setState({ forceHereAddressLookup }, this.resetAddressDiagnostics);
  };

  loadSelectedAddress = async (asset) => {
    var gprmc = this.getGprmc(this.getLastMessage(asset));
    var latitude = this.getGprmcValue(gprmc, ["latitude", "Latitude", "lat", "Lat"]);
    var longitude = this.getGprmcValue(gprmc, ["longitude", "Longitude", "lng", "Lng", "lon", "Lon"]);
    var selectedAddressKey = this.getAddressKey(asset);
    if (!selectedAddressKey) return;

    this.setState({
      selectedAddress: "",
      selectedAddressKey,
      selectedAddressLoading: true,
    });

    var address = await locationCache.getAddress(latitude, longitude);

    if (this.state.selectedAddressKey === selectedAddressKey) {
      this.setState({
        selectedAddress: address || "",
        selectedAddressLoading: false,
      });
    }
  };

  handleAssetSelect = (asset) => {
    var location = this.getLocation(asset);
    var assetId = this.getAssetId(asset);
    this.setFollowSelectedAsset(true);
    this.setState({
      selectedAssetId: assetId,
      selectedAssetSettings: this.getAssetSettingsSnapshot(asset),
      driverAssetEvent: String(assetId) === String(this.state.driverAssetEventAssetId) ? this.state.driverAssetEvent : null,
      driverAssetEventAssetId: String(assetId) === String(this.state.driverAssetEventAssetId) ? this.state.driverAssetEventAssetId : "",
    });
    if (location) {
      this.handleTruckSelection(location);
    }
  };

  handleMapAssetSelection = (assetId) => {
    var asset = this.state.realTimeData.find((item) => String(this.getAssetId(item)) === String(assetId));
    if (asset) {
      var location = this.getLocation(asset);
      this.setFollowSelectedAsset(true);
      this.setState({
        selectedAssetId: this.getAssetId(asset),
        selectedAssetSettings: this.getAssetSettingsSnapshot(asset),
        driverAssetEvent: String(this.getAssetId(asset)) === String(this.state.driverAssetEventAssetId) ? this.state.driverAssetEvent : null,
        driverAssetEventAssetId: String(this.getAssetId(asset)) === String(this.state.driverAssetEventAssetId) ? this.state.driverAssetEventAssetId : "",
      });
      if (location) {
        this.handleTruckFollow(location);
      }
    }
  };

  setFollowSelectedAsset = (followSelectedAsset) => {
    localStorage.setItem("realTimeFollowSelectedAsset", followSelectedAsset ? "true" : "false");
    this.setState({ followSelectedAsset });
  };

  toggleFollowSelectedAsset = () => {
    if (!this.state.selectedAssetId) return;

    var followSelectedAsset = !this.state.followSelectedAsset;
    this.setFollowSelectedAsset(followSelectedAsset);

    if (followSelectedAsset) {
      var selectedAsset = this.getSelectedAsset(this.getActiveAssets(this.state.realTimeData));
      var location = this.getLocation(selectedAsset);
      if (location) {
        this.handleTruckSelection(location);
      }
    }
  };

  handleMapUserMove = () => {
    if (this.state.followSelectedAsset) {
      this.setFollowSelectedAsset(false);
    }
  };

  handleFilterChange = (assetFilter) => {
    localStorage.setItem("realTimeStatusFilter", assetFilter);
    this.setState({ assetFilter });
  };

  handleTypeFilterChange = (assetTypeFilter) => {
    localStorage.setItem("realTimeTypeFilter", assetTypeFilter);
    this.setState({ assetTypeFilter });
  };

  handleSearchChange = (event) => {
    this.setState({ assetSearch: event.target.value });
  };

  clearSearch = () => {
    this.setState({ assetSearch: "" });
  };

  toggleTheme = () => {
    var realtimeTheme = this.state.realtimeTheme === "dark" ? "light" : "dark";
    localStorage.setItem("realtimeTheme", realtimeTheme);
    this.setState({ realtimeTheme });
  };

  setRealtimeViewMode = (realtimeViewMode) => {
    localStorage.setItem("realTimeViewMode", realtimeViewMode);
    this.setState({ realtimeViewMode });
  };

  setListMapEnabled = (listMapEnabled) => {
    localStorage.setItem("realTimeListMapEnabled", listMapEnabled ? "true" : "false");
    this.setState({ listMapEnabled }, () => {
      if (listMapEnabled) {
        window.setTimeout(() => window.dispatchEvent(new Event("resize")), 0);
      }
    });
  };

  setListMapHeight = (listMapHeight) => {
    if (["half", "tall", "extraTall"].indexOf(listMapHeight) === -1) return;
    localStorage.setItem("realTimeListMapHeight", listMapHeight);
    this.setState({ listMapHeight }, () => {
      window.setTimeout(() => window.dispatchEvent(new Event("resize")), 0);
    });
  };

  openAssetMapModal = (event, asset) => {
    event.stopPropagation();
    this.handleAssetSelect(asset);
    this.setState({ mapModalAssetId: asset.assetId });
  };

  handleListAssetMapClick = (event, asset) => {
    event.stopPropagation();

    if (!this.state.listMapEnabled) {
      this.openAssetMapModal(event, asset);
      return;
    }

    // Centre the map without moving the user's page or table scroll position.
    this.handleAssetSelect(asset);
  };

  closeAssetMapModal = () => {
    this.setState({ mapModalAssetId: "" });
  };

  closeReportMenu = () => {
    if (this.state.openReportAssetId || this.state.liveQuickReportMenuOpen || this.state.liveExpandedReportMenuOpen) {
      this.setState({ openReportAssetId: "", liveQuickReportMenuOpen: false, liveExpandedReportMenuOpen: false });
    }
  };

  toggleLiveQuickReportMenu = (event) => {
    event.stopPropagation();

    if (this.state.liveQuickReportMenuOpen) {
      this.setState({ liveQuickReportMenuOpen: false });
      return;
    }

    var liveQuickReportMenuDirection = this.state.liveReportPosition === "bottom" ? "up" : "down";

    this.setState({ liveQuickReportMenuOpen: true, liveQuickReportMenuDirection });
  };

  toggleLiveExpandedReportMenu = (event) => {
    event.stopPropagation();
    this.setState({ liveExpandedReportMenuOpen: !this.state.liveExpandedReportMenuOpen });
  };

  selectLiveExpandedReport = (event, liveReportType) => {
    event.stopPropagation();
    this.setState({ liveReportType, liveExpandedReportMenuOpen: false });
  };

  openQuickLiveReport = (event, asset, reportType) => {
    event.stopPropagation();
    this.setState({ liveQuickReportMenuOpen: false });
    this.openLiveReport(event, asset, getLocalCalendarDate(), reportType);
  };

  toggleReportMenu = (event, assetId) => {
    event.stopPropagation();

    if (this.state.openReportAssetId === assetId) {
      this.setState({ openReportAssetId: "" });
      return;
    }

    var rect = event.currentTarget.getBoundingClientRect();
    var menuHeight = 178;
    var spaceBelow = window.innerHeight - rect.bottom;
    var spaceAbove = rect.top;
    var reportMenuDirection = spaceBelow < menuHeight && spaceAbove > spaceBelow ? "up" : "down";

    this.setState({ openReportAssetId: assetId, reportMenuDirection });
  };

  toggleScrollLock = () => {
    var scrollLockEnabled = !this.state.scrollLockEnabled;
    localStorage.setItem("realTimeScrollLock", scrollLockEnabled ? "true" : "false");
    this.setState({ scrollLockEnabled });
  };

  toggleMapClustering = () => {
    var mapClusteringEnabled = !this.state.mapClusteringEnabled;
    localStorage.setItem("realTimeMapClustering", mapClusteringEnabled ? "true" : "false");
    this.setState({ mapClusteringEnabled });
  };

  getCustomerVisualModes = () => this.getRealtimeVisualModes().filter((mode) => mode.key !== "custom");

  setRealtimeVisualMode = (realtimeVisualMode) => {
    var allowedModes = this.isSystemAdmin() ? ["default", "ignition", "custom"] : ["default", "ignition"];
    if (allowedModes.indexOf(realtimeVisualMode) === -1) return;
    localStorage.setItem("realTimeVisualMode", realtimeVisualMode);
    localStorage.setItem("realTimeCustomIconsEnabled", realtimeVisualMode === "custom" ? "true" : "false");
    this.setState({ realtimeVisualMode });
  };

  handleAssetColourInputChange = (event) => {
    this.setState({ assetColourInput: event.target.value, assetColourResult: null });
  };

  saveAssetColourOverride = async (asset) => {
    var assetId = this.getAssetId(asset);
    if (!assetId) return;

    var colour = this.normalizeColourValue(this.state.assetColourInput);
    if (!colour) {
      this.setState({ assetColourResult: { type: "danger", message: "Enter a valid hex colour, for example #2563eb." } });
      return;
    }

    try {
      await axios.put(
        `${apiHost}/api/Assets/${assetId}/VisualPreference`,
        { assetId, colour },
        { headers: this.getAuthHeaders() }
      );

      var overrides = {
        ...this.state.userAssetColourOverrides,
        [String(assetId)]: colour,
      };
      this.saveUserAssetColourOverrides(overrides);
      this.setState({
        userAssetColourOverrides: overrides,
        assetColourInput: colour,
        assetColourResult: { type: "success", message: "Icon colour saved for your user." },
        mapChange: JSON.stringify([this.applyUserAssetColourOverride({ ...asset, colour })]),
      });
    } catch (e) {
      var message = "Icon colour could not be saved.";
      if (e && e.response && e.response.status == "401") {
        message = "Session ended. Please login again and try.";
        this.props.history.push("/login");
      } else if (e && e.response && e.response.data) {
        message = e.response.data.message || e.response.data.statusResponse || e.response.data;
      }
      this.setState({ assetColourResult: { type: "danger", message } });
    }
  };

  clearAssetColourOverride = async (asset) => {
    var assetId = this.getAssetId(asset);
    if (!assetId) return;

    try {
      await axios.delete(`${apiHost}/api/Assets/${assetId}/VisualPreference`, {
        headers: this.getAuthHeaders(),
      });

      var overrides = { ...this.state.userAssetColourOverrides };
      delete overrides[String(assetId)];
      this.saveUserAssetColourOverrides(overrides);
      this.setState({
        userAssetColourOverrides: overrides,
        assetColourInput: this.getBaseAssetVisualColour(asset) || DEFAULT_REALTIME_VISUAL_COLOUR,
        assetColourResult: { type: "success", message: "User colour override cleared." },
        mapChange: JSON.stringify([asset]),
      });
    } catch (e) {
      var message = "User colour override could not be cleared.";
      if (e && e.response && e.response.status == "401") {
        message = "Session ended. Please login again and try.";
        this.props.history.push("/login");
      } else if (e && e.response && e.response.data) {
        message = e.response.data.message || e.response.data.statusResponse || e.response.data;
      }
      this.setState({ assetColourResult: { type: "danger", message } });
    }
  };

  isDashcamAsset = (asset) => {
    return this.isTruthyFlag(this.getValue(asset, ["DashCamera", "dashCamera", "dashcamera", "dash_camera", "IsDashCamera", "isDashCamera"]));
  };

  isDoorSensorAsset = (asset) => {
    return this.isTruthyFlag(this.getValue(asset, ["DoorSensor", "doorSensor", "doorsensor", "door_sensor", "IsDoorSensor", "isDoorSensor"]));
  };

  filterAssets = (assets) => {
    return assets.filter((asset) => {
      var state = this.getAssetState(asset);
      var matchesState = this.state.assetFilter === "all" || this.state.assetFilter === state;
      var isDashcam = this.isDashcamAsset(asset);
      var matchesType =
        this.state.assetTypeFilter === "all" ||
        (this.state.assetTypeFilter === "dashcams" && isDashcam) ||
        (this.state.assetTypeFilter === "trackers" && !isDashcam);

      if (!matchesState || !matchesType) return false;

      return true;
    });
  };

  filterAssetList = (assets) => {
    var search = this.state.assetSearch.trim().toLowerCase();
    var filteredAssets = this.filterAssets(assets);

    return filteredAssets.filter((asset) => {
      if (!search) return true;

      var haystack = [
        asset.assetName,
        asset.friendlyName,
        asset.statusString,
        asset.serialno,
        asset.iButtonName,
        this.getMessageAddress(this.getLastMessage(asset)),
        this.getListAddress(asset),
      ].join(" ").toLowerCase();

      return haystack.indexOf(search) !== -1;
    });
  };

  renderDetailRow = (label, value) => (
    <div className="ping-detail-row">
      <span>{label}</span>
      <strong>{value || "-"}</strong>
    </div>
  );

  renderLiveDetailRow = (label, value, options = {}) => (
    <div className={options.className ? `live-detail-row ${options.className}` : "live-detail-row"}>
      <span className="live-detail-label">{label}</span>
      <strong className={options.valueClassName ? `live-detail-value ${options.valueClassName}` : "live-detail-value"}>
        {options.iconNode}
        {options.icon && <span className="live-detail-icon" aria-hidden="true">{options.icon}</span>}
        {value || "-"}
        {options.meta && <span className="live-detail-meta">{options.meta}</span>}
      </strong>
    </div>
  );

  renderCopyButton = (value, options = {}) => {
    if (!value) return null;
    var copyKey = options.copyKey || String(value);
    var isCopied = this.state.copiedButtonKey === copyKey;

    return (
      <button
        type="button"
        className={[
          "live-copy-button",
          options.className,
          isCopied ? "copied" : "",
        ].filter(Boolean).join(" ")}
        title={isCopied ? "Copied" : (options.title || "Copy")}
        onClick={() => this.copyValue(value, copyKey)}
      >
        {isCopied && options.copiedIcon ? (
          <i className={options.copiedIcon} aria-hidden="true"></i>
        ) : options.icon ? (
          <i className={options.icon} aria-hidden="true"></i>
        ) : (
          options.label || "Copy"
        )}
      </button>
    );
  };

  copyValue = (value, copyKey) => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(String(value));
    }

    if (this.copyFeedbackTimer) {
      clearTimeout(this.copyFeedbackTimer);
    }
    this.setState({ copiedButtonKey: copyKey });
    this.copyFeedbackTimer = setTimeout(() => {
      this.setState({ copiedButtonKey: "" });
      this.copyFeedbackTimer = null;
    }, 900);
  };

  renderAdminDetailRow = (label, value, copyValue) => (
    <div className="admin-asset-detail-row">
      <span>{label}</span>
      <strong>
        {value || "-"}
        {copyValue && this.renderCopyButton(copyValue)}
      </strong>
    </div>
  );

  getDirectionsUrl = (latitude, longitude) => {
    if (!latitude || !longitude) return "";
    var numericLat = Number(latitude);
    var numericLng = Number(longitude);
    if (!Number.isFinite(numericLat) || !Number.isFinite(numericLng)) return "";
    var params = new URLSearchParams({
      api: "1",
      origin: `${numericLat},${numericLng}`,
      travelmode: "driving",
    });
    return `https://www.google.com/maps/dir/?${params.toString()}`;
  };

  handleLiveReportTypeChange = (event) => {
    this.setState({ liveReportType: event.target.value });
  };

  setLiveReportMode = (liveReportMode) => {
    localStorage.setItem("realTimeLiveReportMode", liveReportMode);
    this.setState({
      liveReportMode,
      liveReportDate: liveReportMode === "quick" ? getLocalCalendarDate() : this.state.liveReportDate,
      liveQuickReportMenuOpen: false,
      liveExpandedReportMenuOpen: false,
    });
  };

  setLiveReportPosition = (liveReportPosition) => {
    localStorage.setItem("realTimeLiveReportPosition", liveReportPosition);
    this.setState({ liveReportPosition, liveQuickReportMenuOpen: false, liveExpandedReportMenuOpen: false });
  };

  handleQuickLiveReportChange = (event, asset) => {
    var reportType = event.target.value;
    if (!reportType) return;
    this.openLiveReport(event, asset, getLocalCalendarDate(), reportType);
  };

  handleLiveReportDateChange = (event) => {
    this.setState({ liveReportDate: event.target.value });
  };

  getLiveReportUrl = (asset, reportDate, reportTypeOverride) => {
    var reportType = reportTypeOverride || this.state.liveReportType || "/Track";
    var encodedAssetId = encodeURIComponent(asset.assetId);
    var encodedAssetName = encodeURIComponent(asset.assetName || "");
    var groupId = this.props.realTimeGroupId || localStorage.getItem("realTimeGroupId");
    var groupQuery = groupId && groupId !== "all" ? `&groupId=${encodeURIComponent(groupId)}` : "";

    if (reportType === "/Rpt-MVTL") {
      return `/Rpt-MVTL?assetId=${encodedAssetId}&assetName=${encodedAssetName}&SearchDate=${reportDate}${groupQuery}`;
    }
    if (reportType === "/Rpt-Visit") {
      return `/Rpt-Visit?assetId=${encodedAssetId}&assetName=${encodedAssetName}&SearchDate=${reportDate}${groupQuery}`;
    }
    if (reportType === "/Temperature") {
      return `/Temperature?assetId=${encodedAssetId}&assetName=${encodedAssetName}${groupQuery}`;
    }
    if (reportType === "/Rpt-LocationData") {
      return `/Rpt-LocationData?assetId=${encodedAssetId}&assetName=${encodedAssetName}&SearchDate=${reportDate}${groupQuery}`;
    }
    if (reportType === "/Timeline") {
      return `/Timeline?assetId=${encodedAssetId}&assetName=${encodedAssetName}&SearchDate=${reportDate}&assetDate=${reportDate}${groupQuery}`;
    }
    if (reportType === "/Replay") {
      return `/Replay?assetId=${encodedAssetId}&assetName=${encodedAssetName}&selectedDate=${reportDate}&tz=${encodeURIComponent(localStorage.getItem("timeZoneID") || "Australia/Melbourne")}${groupQuery}`;
    }
    return `/Track?assetId=${encodedAssetId}&assetName=${encodedAssetName}${groupQuery}`;
  };

  openLiveReport = (event, asset, reportDate, reportTypeOverride) => {
    event.preventDefault();

    var href = this.getLiveReportUrl(asset, reportDate, reportTypeOverride);
    var browserWindow = window.opener && !window.opener.closed ? window.opener : window;
    var reportWindow = browserWindow.open(href, "_blank");

    this.setState({ openReportAssetId: "" });

    if (reportWindow) {
      reportWindow.focus();
      return;
    }

    window.open(href, "_blank");
  };

  openAdminAssetModal = () => {
    var selectedAsset = this.getSelectedAsset(this.getActiveAssets(this.state.realTimeData));
    var mobile = selectedAsset ? this.getValue(selectedAsset, ["sim", "SIM", "Sim", "mobile", "Mobile"]) : "";
    this.setState({
      adminAssetModalOpen: true,
      adminSmsDestinationNumber: mobile || "",
      adminSmsContent: "",
      adminSmsSending: false,
      adminSmsResult: null,
      adminSmsMessages: [],
      adminSmsMessagesLoading: false,
    });
    this.loadAdminSmsPresets();
    this.loadAdminSmsMessages(selectedAsset, mobile);
    this.startAdminSmsPolling();
  };

  closeAdminAssetModal = () => {
    if (this.state.adminSmsSending) return;
    this.stopAdminSmsPolling();
    this.setState({
      adminAssetModalOpen: false,
      adminSmsDestinationNumber: "",
      adminSmsContent: "",
      adminSmsResult: null,
      adminSmsMessages: [],
      adminSmsMessagesLoading: false,
    });
  };

  openAssetSettingsModal = () => {
    var selectedAsset = this.getSelectedAsset(this.getActiveAssets(this.state.realTimeData));
    var canSetOdometer = this.canSetOdometerForSelectedAsset(selectedAsset);

    var odometer = selectedAsset ? this.getMessageValue(this.getLastMessage(selectedAsset), ["odometer", "Odometer"]) : "";
    var assetColour = selectedAsset ? this.getUserAssetColourOverride(selectedAsset) || this.getAssetVisualColour(selectedAsset) || DEFAULT_REALTIME_VISUAL_COLOUR : DEFAULT_REALTIME_VISUAL_COLOUR;
    this.setState({
      assetSettingsModalOpen: true,
      assetCommandStatusLoading: canSetOdometer,
      assetCommandStatus: null,
      odometerInputKm: this.formatWholeKm(odometer),
      odometerSubmitting: false,
      odometerResult: null,
      odometerSteps: this.getOdometerDefaultSteps(),
      odometerJobId: "",
      assetColourInput: assetColour,
      assetColourResult: null,
    });

    if (canSetOdometer) {
      this.loadAssetCommandStatus(selectedAsset);
      this.startOdometerStatusPolling();
    }
  };

  closeAssetSettingsModal = () => {
    if (this.state.odometerSubmitting) return;
    this.stopOdometerStatusPolling();
    this.stopOdometerJobPolling();
    this.setState({
      assetSettingsModalOpen: false,
      assetCommandStatusLoading: false,
      assetCommandStatus: null,
      odometerInputKm: "",
      odometerSubmitting: false,
      odometerResult: null,
      odometerSteps: [],
      odometerJobId: "",
      assetColourInput: "",
      assetColourResult: null,
    });
  };

  loadAssetCommandStatus = (asset, silent) => {
    var assetId = this.getAssetId(asset);
    if (!asset || !assetId) {
      this.setState({ assetCommandStatusLoading: false, assetCommandStatus: null });
      return;
    }

    if (!silent) {
      this.setState({ assetCommandStatusLoading: true });
    }
    axios
      .get(`${apiHost}/api/Assets/${assetId}/OdometerCommandStatus`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((response) => {
        this.setState({
          assetCommandStatusLoading: false,
          assetCommandStatus: response.data || null,
        });
      })
      .catch(() => {
        this.setState({
          assetCommandStatusLoading: false,
          assetCommandStatus: { isOnline: false },
        });
      });
  };

  startOdometerStatusPolling = () => {
    this.stopOdometerStatusPolling();
    this.odometerStatusPollTimer = setInterval(() => {
      if (!this.state.assetSettingsModalOpen || document.hidden) return;
      var selectedAsset = this.getSelectedAsset(this.getActiveAssets(this.state.realTimeData));
      if (selectedAsset) {
        this.loadAssetCommandStatus(selectedAsset, true);
      }
    }, 3000);
  };

  stopOdometerStatusPolling = () => {
    if (this.odometerStatusPollTimer) {
      clearInterval(this.odometerStatusPollTimer);
      this.odometerStatusPollTimer = null;
    }
  };

  startOdometerJobPolling = (jobId, asset) => {
    this.stopOdometerJobPolling();
    this.pollOdometerJob(jobId, asset);
    this.odometerJobPollTimer = setInterval(() => {
      if (!this.state.assetSettingsModalOpen || document.hidden) return;
      this.pollOdometerJob(jobId, asset);
    }, 700);
  };

  stopOdometerJobPolling = () => {
    if (this.odometerJobPollTimer) {
      clearInterval(this.odometerJobPollTimer);
      this.odometerJobPollTimer = null;
    }
  };

  pollOdometerJob = (jobId, asset) => {
    if (!jobId) return;
    axios
      .get(`${apiHost}/api/Assets/OdometerCommandJobs/${jobId}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((response) => {
        var data = response.data || {};
        var isComplete = data.isComplete || data.status === "complete" || data.status === "failed";
        this.setState({
          odometerSteps: this.normalizeOdometerSteps(data.steps),
          odometerSubmitting: !isComplete,
          odometerResult: isComplete
            ? { type: data.status === "failed" ? "danger" : "success", message: data.message || (data.status === "failed" ? "Odometer command failed." : "Odometer command sent.") }
            : { type: "info", message: data.message || "Sending odometer commands..." },
        });
        if (isComplete) {
          this.stopOdometerJobPolling();
          this.loadAssetCommandStatus(asset, true);
        }
      })
      .catch(() => {
        this.stopOdometerJobPolling();
        this.setState({
          odometerSubmitting: false,
          odometerResult: { type: "danger", message: "Could not read odometer command progress." },
        });
      });
  };

  getOdometerDefaultSteps = () => [
    { label: "Erase backup", status: "pending" },
    { label: "Set new value", status: "pending" },
    { label: "Backup", status: "pending" },
    { label: "Reboot", status: "pending" },
  ];

  normalizeOdometerSteps = (steps) => {
    var defaults = this.getOdometerDefaultSteps();
    if (!Array.isArray(steps) || !steps.length) return defaults;
    return defaults.map((defaultStep, index) => {
      var step = steps[index] || {};
      return {
        label: step.label || defaultStep.label,
        status: step.status || (step.success ? "success" : defaultStep.status),
        response: step.response || "",
      };
    });
  };

  renderOdometerProgressSteps = () => {
    if (!this.state.odometerSteps.length && !this.state.odometerSubmitting && !this.state.odometerResult) return null;
    var steps = this.state.odometerSteps.length ? this.state.odometerSteps : this.getOdometerDefaultSteps();

    return (
      <div className="odometer-progress-steps">
        {steps.map((step, index) => (
          <div className={`odometer-progress-step ${step.status || "pending"}`} key={`odometer-step-${index}`}>
            <span className="odometer-step-number">{index + 1}</span>
            <span className="odometer-step-label">{step.label}</span>
            <strong>{step.status === "success" ? "Success" : step.status === "failed" ? "Failed" : step.status === "running" ? "Sending..." : "Pending"}</strong>
          </div>
        ))}
      </div>
    );
  };

  handleOdometerInputChange = (event) => {
    this.setState({ odometerInputKm: event.target.value, odometerResult: null });
  };

  submitOdometerUpdate = async (asset) => {
    var assetId = this.getAssetId(asset);
    if (!asset || !assetId || this.state.odometerSubmitting) return;
    if (!this.canSetOdometerForSelectedAsset(asset)) {
      this.setState({ odometerResult: { type: "danger", message: "Set Odometer is only available for FOX3 devices." } });
      return;
    }

    var odometerKm = Number(this.state.odometerInputKm);
    if (!Number.isFinite(odometerKm) || odometerKm < 0) {
      this.setState({ odometerResult: { type: "danger", message: "Enter a valid odometer value in kilometres." } });
      return;
    }
    odometerKm = Math.round(odometerKm);

    this.stopOdometerJobPolling();
    this.setState({ odometerSubmitting: true, odometerResult: { type: "info", message: "Starting odometer update..." }, odometerSteps: this.getOdometerDefaultSteps(), odometerJobId: "" });

    try {
      var response = await axios.post(
        `${apiHost}/api/Assets/${assetId}/SetOdometer`,
        { odometerKm },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      this.setState({
        odometerSubmitting: true,
        odometerJobId: response.data && response.data.jobId ? response.data.jobId : "",
        odometerSteps: this.normalizeOdometerSteps(response.data && response.data.steps),
        odometerResult: {
          type: "info",
          message: response.data && response.data.message ? response.data.message : "Odometer update started.",
        },
      });
      if (response.data && response.data.jobId) {
        this.startOdometerJobPolling(response.data.jobId, asset);
      } else {
        this.setState({ odometerSubmitting: false });
      }
    } catch (e) {
      var message = "Odometer command could not be sent.";
      if (e.response && e.response.data) {
        message = e.response.data.message || e.response.data.statusResponse || e.response.data;
      }
      if (e.response && e.response.status == "401") {
        message = "Session ended. Please login again and try.";
      }

      this.setState({
        odometerSubmitting: false,
        assetCommandStatus: e.response && e.response.status === 409 ? { ...(this.state.assetCommandStatus || {}), isOnline: false } : this.state.assetCommandStatus,
        odometerSteps: this.normalizeOdometerSteps(e.response && e.response.data && e.response.data.steps),
        odometerJobId: "",
        odometerResult: { type: "danger", message },
      });
    }
  };

  startAdminSmsPolling = () => {
    this.stopAdminSmsPolling();
    this.adminSmsPollTimer = setInterval(() => {
      if (!this.state.adminAssetModalOpen || document.hidden) return;
      var selectedAsset = this.getSelectedAsset(this.getActiveAssets(this.state.realTimeData));
      if (selectedAsset) {
        this.loadAdminSmsMessages(selectedAsset, undefined, true);
      }
    }, 5000);
  };

  stopAdminSmsPolling = () => {
    if (this.adminSmsPollTimer) {
      clearInterval(this.adminSmsPollTimer);
      this.adminSmsPollTimer = null;
    }
  };

  scrollAdminSmsThreadToBottom = () => {
    window.setTimeout(() => {
      if (!this.adminSmsThreadRef || !this.adminSmsThreadRef.current) return;
      this.adminSmsThreadRef.current.scrollTop = this.adminSmsThreadRef.current.scrollHeight;
    }, 0);
  };

  handleAdminSmsDestinationChange = (event) => {
    this.setState({ adminSmsDestinationNumber: event.target.value });
  };

  handleAdminSmsContentChange = (event) => {
    this.setState({ adminSmsContent: event.target.value });
  };

  applyAdminSmsPreset = (command) => {
    this.setState({ adminSmsContent: command });
  };

  loadAdminSmsPresets = () => {
    this.setState({ adminSmsPresetLoading: true });
    axios
      .get(`${apiHost}/api/Sms/CommandPresets`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((response) => {
        if (response.data && response.data.length) {
          this.setState({ adminSmsPresets: this.normalizeAdminSmsPresets(response.data), adminSmsPresetLoading: false });
        } else {
          this.setState({ adminSmsPresets: DEFAULT_ADMIN_SMS_COMMAND_PRESETS, adminSmsPresetLoading: false });
        }
      })
      .catch(() => {
        this.setState({ adminSmsPresets: DEFAULT_ADMIN_SMS_COMMAND_PRESETS, adminSmsPresetLoading: false });
      });
  };

  normalizeAdminSmsPresets = (presets) => {
    return DEFAULT_ADMIN_SMS_COMMAND_PRESETS.map((defaultPreset, index) => {
      var preset = presets[index] || {};
      return {
        id: preset.id || 0,
        sortOrder: preset.sortOrder || index + 1,
        label: preset.label !== undefined ? preset.label : defaultPreset.label,
        command: preset.command !== undefined ? preset.command : defaultPreset.command,
      };
    });
  };

  saveAdminSmsPresets = () => {
    this.setState({ adminSmsPresetSaving: true, adminSmsResult: null });
    axios
      .put(`${apiHost}/api/Sms/CommandPresets`, this.state.adminSmsPresets, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((response) => {
        this.setState({
          adminSmsPresets: this.normalizeAdminSmsPresets(response.data || []),
          adminSmsPresetSaving: false,
          adminSmsPresetEditorOpen: false,
          adminSmsResult: { type: "success", message: "SMS command buttons saved." },
        });
      })
      .catch((e) => {
        var message = "SMS command buttons could not be saved.";
        if (e.response && e.response.data) {
          message = e.response.data.message || e.response.data.statusResponse || e.response.data;
        }
        this.setState({
          adminSmsPresetSaving: false,
          adminSmsResult: { type: "danger", message },
        });
      });
  };

  toggleAdminSmsPresetEditor = () => {
    this.setState({ adminSmsPresetEditorOpen: !this.state.adminSmsPresetEditorOpen });
  };

  updateAdminSmsPreset = (index, field, value) => {
    var presets = this.state.adminSmsPresets.map((preset, presetIndex) =>
      presetIndex === index ? { ...preset, [field]: value } : preset
    );
    this.setState({ adminSmsPresets: presets });
  };

  loadAdminSmsMessages = (asset, numberOverride, silent) => {
    if (!asset) return;

    var mobile = numberOverride !== undefined ? numberOverride : this.state.adminSmsDestinationNumber;
    if (!mobile) {
      this.setState({ adminSmsMessages: [], adminSmsMessagesLoading: false });
      return;
    }

    if (!silent) {
      this.setState({ adminSmsMessagesLoading: true });
    }
    axios
      .get(`${apiHost}/api/Sms/Messages`, {
        params: {
          number: mobile,
          assetId: asset.assetId || "",
        },
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
      .then((response) => {
        var messages = Array.isArray(response.data) ? response.data : [];
        var normalizedMessages = messages.map((message) => ({
          id: message.id,
          direction: message.direction || "received",
          content: message.content || "",
          created: message.created,
        }));
        var existingMessageKey = this.state.adminSmsMessages.map((message) => `${message.id || ""}:${message.created || ""}`).join("|");
        var incomingMessageKey = normalizedMessages.map((message) => `${message.id || ""}:${message.created || ""}`).join("|");
        if (silent && existingMessageKey === incomingMessageKey) {
          return this.setState({ adminSmsMessagesLoading: false });
        }
        this.setState({
          adminSmsMessages: normalizedMessages,
          adminSmsMessagesLoading: false,
        });
      })
      .catch(() => {
        this.setState({ adminSmsMessagesLoading: false });
      });
  };

  appendAdminSmsMessage = (asset, message) => {
    var messages = [...this.state.adminSmsMessages, message].slice(-50);
    this.setState({ adminSmsMessages: messages });
  };

  formatAdminSmsTime = (dateValue) => {
    var normalizedDateValue =
      typeof dateValue === "string" && dateValue.indexOf("Z") === -1 && dateValue.indexOf("+") === -1
        ? `${dateValue}Z`
        : dateValue;
    var date = normalizedDateValue ? new Date(normalizedDateValue) : new Date();
    if (isNaN(date.getTime())) return "";
    return date.toLocaleString("en-AU", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  formatRealtimeListLastRefreshed = () => {
    if (!this.state.realtimeListLastRefreshed) return "Not yet";
    return this.state.realtimeListLastRefreshed.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  sendAdminSms = async (asset) => {
    if (!asset) return;

    var smsText = this.state.adminSmsContent.trim();
    if (!smsText) return;

    this.setState({ adminSmsSending: true, adminSmsResult: null });

    try {
      var response = await axios.post(
        `${apiHost}/api/Sms/Send`,
        {
          destinationNumber: this.state.adminSmsDestinationNumber,
          content: smsText,
          assetId: asset.assetId || "",
          assetName: asset.assetName || "",
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );

      this.appendAdminSmsMessage(asset, {
        id: Date.now(),
        direction: "sent",
        content: smsText,
        created: new Date().toISOString(),
      });

      this.setState({
        adminSmsContent: "",
        adminSmsSending: false,
        adminSmsResult: {
          type: "success",
          message: response.data && response.data.message ? response.data.message : "SMS sent.",
        },
      });
      this.loadAdminSmsMessages(asset);
    } catch (e) {
      var message = "SMS could not be sent.";
      if (e.response && e.response.data) {
        message = e.response.data.message || e.response.data.statusResponse || e.response.data;
      }
      if (e.response && e.response.status == "401") {
        message = "Session ended. Please login again and try.";
      }

      this.setState({
        adminSmsSending: false,
        adminSmsResult: {
          type: "danger",
          message,
        },
      });
    }
  };

  formatOdometer = (value) => {
    if (value === null || value === undefined || value === "") return "";
    var numericValue = Number(value);
    return Number.isNaN(numericValue) ? value : numericValue.toFixed(1);
  };

  formatWholeKm = (value) => {
    if (value === null || value === undefined || value === "") return "";
    var numericValue = Number(value);
    return Number.isNaN(numericValue) ? value : Math.round(numericValue).toString();
  };

  formatListSpeed = (value) => {
    if (value === null || value === undefined || value === "") return "";
    var numericValue = Number(value);
    return Number.isNaN(numericValue) ? value : numericValue.toFixed(1);
  };

  formatVolts = (value) => {
    if (value === null || value === undefined || value === "") return "";
    return `${value} V`;
  };

  renderFridgePill = (value) => {
    if (value === null || value === undefined || value === "") return "-";
    var isOn = value == 1;
    return (
      <span className={isOn ? "fridge-pill fridge-on" : "fridge-pill fridge-off"}>
        <i className="fa fa-snowflake-o fridge-snowflake" aria-hidden="true"></i>
        {isOn ? "ON" : "OFF"}
      </span>
    );
  };

  renderDoorSensorPill = (value) => {
    if (value === null || value === undefined || value === "") return "-";
    var isClosed = value == 1;
    return (
      <span className={isClosed ? "door-sensor-pill door-sensor-closed" : "door-sensor-pill door-sensor-open"}>
        {isClosed ? "Closed" : "Open"}
      </span>
    );
  };

  renderVoltageValue = (value) => {
    var formattedVolts = this.formatVolts(value);
    if (!formattedVolts) return "";

    var isLowVoltage = this.isLowVoltage(value);
    return (
      <span className={isLowVoltage ? "voltage-value low-voltage" : "voltage-value"}>
        {isLowVoltage && <span className="voltage-warning-icon" title="Low voltage">⚠️</span>}
        {formattedVolts}
      </span>
    );
  };

  formatTemperatureValue = (value) => {
    return value !== null && value !== undefined && value !== "" ? `${value}°C` : "-";
  };

  renderColdChainDetailRow = (tempA, tempB, fridge) => (
    <div className="live-detail-row cold-chain-detail-row">
      <div className="cold-chain-pair">
        <span className="cold-chain-reading">
          <span className="temperature-secondary-label">Temp A:</span>
          <span>{this.formatTemperatureValue(tempA)}</span>
        </span>
        <span className="cold-chain-reading">
          <span className="temperature-secondary-label">Temp B:</span>
          <span>{this.formatTemperatureValue(tempB)}</span>
        </span>
        <span className="cold-chain-reading fridge-reading">
          <span className="temperature-secondary-label">Fridge:</span>
          {this.renderFridgePill(fridge)}
        </span>
      </div>
    </div>
  );

  renderDoorSensorDetailRow = (doorSensor) => (
    <div className="live-detail-row door-sensor-detail-row">
      <span className="live-detail-label">Door Sensor:</span>
      <strong className="live-detail-value door-sensor-detail-value">
        {this.renderDoorSensorPill(doorSensor)}
      </strong>
    </div>
  );

  renderDistanceDetailRow = (trip, odometer) => (
    <div className="live-detail-row distance-detail-row">
      <span className="live-detail-label">Trip:</span>
      <strong className="live-detail-value distance-detail-value">
        <span className="distance-trip-value">{trip ? `${trip} km` : "-"}</span>
        <span className="distance-odometer-group">
          <span className="distance-secondary-label">Odometer:</span>
          <span>{odometer !== null && odometer !== undefined && odometer !== "" ? `${this.formatOdometer(odometer)} km` : "-"}</span>
        </span>
      </strong>
    </div>
  );

  formatStatusAge = (created) => {
    if (!created) return "";

    var statusDate = new Date(created);
    if (isNaN(statusDate.getTime())) return "";

    var seconds = Math.max(0, Math.floor((Date.now() - statusDate.getTime()) / 1000));
    var units = [
      { label: "y", seconds: 365 * 24 * 60 * 60 },
      { label: "mo", seconds: 30 * 24 * 60 * 60 },
      { label: "d", seconds: 24 * 60 * 60 },
      { label: "h", seconds: 60 * 60 },
      { label: "m", seconds: 60 },
      { label: "s", seconds: 1 },
    ];
    var parts = [];

    for (var index = 0; index < units.length; index++) {
      var unitValue = Math.floor(seconds / units[index].seconds);
      if (!unitValue && parts.length === 0 && units[index].label !== "s") continue;
      if (unitValue || parts.length) {
        parts.push(`${unitValue}${units[index].label}`);
        seconds -= unitValue * units[index].seconds;
      }
      if (parts.length === 2) break;
    }

    return parts.length ? parts.join(" ") : "0s";
  };

  getGpsTimeDetail = (message) => {
    var timestamp = this.getMessageTimestamp(message);
    var age = this.formatStatusAge(timestamp);

    return {
      value: utcToReportDateWithZone(timestamp) || utcToReportDate(timestamp),
      meta: age ? `(${age} ago)` : "",
    };
  };

  renderGpsDetailValue = (message, latitude, longitude, satellites) => {
    var gpsLocked = this.isGpsLocked(message);
    var hasPosition = latitude && longitude;
    var positionText = hasPosition ? `${latitude}, ${longitude}` : "";

    return (
      <span className="gps-detail-value">
        <span className="gps-satellite-group">
          <span className={gpsLocked ? "gps-state-globe valid" : "gps-state-globe invalid"} title={gpsLocked ? "GPS valid (A)" : "GPS invalid (V)"}>
            <i className="fa fa-globe" aria-hidden="true"></i>
          </span>
          <span className="gps-satellite-count">({satellites || 0})</span>
        </span>
        {hasPosition ? (
          <span className="gps-position-group">
            <span className="gps-position-label">Position:</span>
            <span className="gps-position-text">{positionText}</span>
            {this.renderCopyButton(positionText, {
              className: "gps-copy-button",
              copyKey: "gps-position",
              copiedIcon: "fa fa-check",
              icon: "fa fa-copy",
              title: "Copy position"
            })}
          </span>
        ) : (
          <span className="gps-position-text">-</span>
        )}
      </span>
    );
  };

  getLiveStatusSinceDetail = (asset, state) => {
    if (state === "driving" || state === "parked") {
      var statusAge = this.formatStatusAge(asset.lastStatusChange);
      return {
        label: state === "driving" ? "Driving Since:" : "Parked Since:",
        value: statusAge ? `${statusAge} ago` : "",
      };
    }

    return {
      label: "Status:",
      value: asset.statusString || state,
    };
  };

  isLowVoltage = (value) => {
    if (value === null || value === undefined || value === "") return false;
    var numericValue = Number(value);
    return !Number.isNaN(numericValue) && numericValue < 12;
  };

  hasTemperatureData = (message) => {
    if (!message) return false;
    var sensorAValue = this.getMessageValue(message, ["sensorAValue", "SensorAValue"]);
    var sensorBValue = this.getMessageValue(message, ["sensorBValue", "SensorBValue"]);
    var fridgeState = this.getMessageValue(message, ["iO1", "IO1", "io1"]);
    var hasTempA = sensorAValue !== null && sensorAValue !== undefined && sensorAValue !== "";
    var hasTempB = sensorBValue !== null && sensorBValue !== undefined && sensorBValue !== "";
    var hasFridge = fridgeState !== null && fridgeState !== undefined;
    return hasTempA || hasTempB || hasFridge;
  };

  hasSensorTemperatureData = (message) => {
    if (!message) return false;
    var sensorAValue = this.getMessageValue(message, ["sensorAValue", "SensorAValue"]);
    var sensorBValue = this.getMessageValue(message, ["sensorBValue", "SensorBValue"]);
    var hasTempA = sensorAValue !== null && sensorAValue !== undefined && sensorAValue !== "";
    var hasTempB = sensorBValue !== null && sensorBValue !== undefined && sensorBValue !== "";
    return hasTempA || hasTempB;
  };

  renderAssetDetailsContent = (asset, reportDate) => {
    if (!asset) {
      return (
        <div className="ping-card empty-details">
          <h2>Asset Info</h2>
          <div className="empty-details-content">
            <span className="empty-details-pin" aria-hidden="true">📍</span>
            <strong>Select an asset</strong>
            <p>Click on an asset in the list or a marker on the map to view live details.</p>
          </div>
        </div>
      );
    }

    var message = this.getLastMessage(asset);
    var gprmc = this.getGprmc(message);
    var latitude = this.getGprmcValue(gprmc, ["latitude", "Latitude", "lat", "Lat"]);
    var longitude = this.getGprmcValue(gprmc, ["longitude", "Longitude", "lng", "Lng", "lon", "Lon"]);
    var speed = this.getGprmcValue(gprmc, ["speed", "Speed"]);
    var heading = this.getGprmcValue(gprmc, ["heading", "Heading"]);
    var trip = this.getMessageValue(message, ["tripCount", "TripCount"]);
    var odometer = this.getMessageValue(message, ["odometer", "Odometer"]);
    var volts = this.getMessageValue(message, ["deviceVolts", "DeviceVolts"]);
    var messageId = this.getMessageIdDisplay(message);
    var fridge = this.getMessageValue(message, ["iO1", "IO1", "io1"]);
    var doorSensor = this.getMessageValue(message, ["iO2", "IO2", "io2"]);
    var tempA = this.getMessageValue(message, ["sensorAValue", "SensorAValue"]);
    var tempB = this.getMessageValue(message, ["sensorBValue", "SensorBValue"]);
    var satellites = this.getMessageValue(message, ["satellites", "Satellites"]);
    var depotName = this.getValue(asset, ["depotName", "DepotName", "depot", "Depot"]);
    var state = this.getAssetState(asset);
    var selectedAddressFallback = this.getMessageAddress(message) || this.getListAddress(asset);
    var address =
      String(asset.assetId) === String(this.state.selectedAssetId)
        ? this.state.selectedAddress || selectedAddressFallback
        : this.getListAddress(asset) || this.getMessageAddress(message);
    var directionsUrl = this.getDirectionsUrl(latitude, longitude);
    var selectedReportDate = this.state.liveReportDate || reportDate;
    var liveStatusSinceDetail = this.getLiveStatusSinceDetail(asset, state);
    var gpsTimeDetail = this.getGpsTimeDetail(message);
    var pingHealth = this.getPingHealth(asset);
    var reportCard = (
      <section className="ping-card reports-card">
        <h3>Reports</h3>
        {this.state.liveReportMode === "quick" ? (
          <div className="live-report-controls quick">
            <div className="live-quick-report-menu">
              <button type="button" className="live-quick-report-toggle" onClick={this.toggleLiveQuickReportMenu} aria-haspopup="menu" aria-expanded={this.state.liveQuickReportMenuOpen}>
                <span>Select report...</span>
                <i className={`fa fa-angle-${this.state.liveQuickReportMenuOpen && this.state.liveQuickReportMenuDirection === "up" ? "up" : "down"}`} aria-hidden="true"></i>
              </button>
              {this.state.liveQuickReportMenuOpen && (
                <div className={this.state.liveQuickReportMenuDirection === "up" ? "live-quick-report-dropdown drop-up" : "live-quick-report-dropdown"} role="menu">
                  {LIVE_REPORT_OPTIONS.map((option) => (
                    <button type="button" role="menuitem" key={option.value} onClick={(event) => this.openQuickLiveReport(event, asset, option.value)}>{option.label}</button>
                  ))}
                </div>
              )}
            </div>
          </div>
        ) : (
          <React.Fragment>
            <div className="live-report-controls">
              <div className="live-quick-report-menu">
                <button type="button" className="live-quick-report-toggle" onClick={this.toggleLiveExpandedReportMenu} aria-haspopup="menu" aria-expanded={this.state.liveExpandedReportMenuOpen}>
                  <span>{LIVE_REPORT_OPTIONS.find((option) => option.value === this.state.liveReportType)?.label || "Track"}</span>
                  <i className={`fa fa-angle-${this.state.liveExpandedReportMenuOpen && this.state.liveReportPosition === "bottom" ? "up" : "down"}`} aria-hidden="true"></i>
                </button>
                {this.state.liveExpandedReportMenuOpen && (
                  <div className={this.state.liveReportPosition === "bottom" ? "live-quick-report-dropdown drop-up" : "live-quick-report-dropdown"} role="menu">
                    {LIVE_REPORT_OPTIONS.map((option) => (
                      <button type="button" role="menuitemradio" aria-checked={this.state.liveReportType === option.value} className={this.state.liveReportType === option.value ? "active" : ""} key={option.value} onClick={(event) => this.selectLiveExpandedReport(event, option.value)}>{option.label}</button>
                    ))}
                  </div>
                )}
              </div>
              <input type="date" value={selectedReportDate} onChange={this.handleLiveReportDateChange} />
            </div>
            <div className="report-link-grid live-report-actions">
              {/* eslint-disable-next-line react/jsx-no-target-blank */}
              <a href={this.getLiveReportUrl(asset, selectedReportDate)} target="_blank" rel="opener" onClick={(event) => this.openLiveReport(event, asset, selectedReportDate)}>Open</a>
            </div>
          </React.Fragment>
        )}
      </section>
    );

    return (
      <React.Fragment>
        {this.state.liveReportPosition === "top" && reportCard}

        <section className="ping-card live-detail-card">
          <div className="live-asset-header">
            <div className="live-asset-title-row">
              <h2>Asset</h2>
              <div className="live-asset-actions">
                {canAccessVideo() && this.isDashcamAsset(asset) && <button type="button" className={`realtime-video-button realtime-video-button-${this.getVideoCameraStatus(asset)}`} title={`Video for ${asset.assetName} — camera ${this.getVideoCameraStatus(asset)}`} aria-label={`Video for ${asset.assetName} — camera ${this.getVideoCameraStatus(asset)}`} onClick={() => this.setState({ videoAsset: asset })}><i className="fa fa-video-camera" aria-hidden="true"></i></button>}
                {this.isSystemAdmin() && (
                  <button type="button" className="admin-asset-button" onClick={this.openAdminAssetModal}>
                    Admin
                  </button>
                )}
                <button type="button" className="asset-settings-button" onClick={this.openAssetSettingsModal} title="Asset settings" aria-label="Asset settings">
                  <i className="fa fa-cog" aria-hidden="true"></i>
                </button>
                {directionsUrl ? (
                  <a className="directions-link" href={directionsUrl} target="_blank" rel="noreferrer">Directions</a>
                ) : (
                  <span className="directions-link disabled">Directions</span>
                )}
              </div>
            </div>
            <div className="live-asset-identity">
              <span className={state === "driving" ? "engine-driving" : "engine-park"}>{state === "driving" ? "D" : "P"}</span>
              <div>
                <strong>{asset.assetName}</strong>
                {asset.friendlyName && <p>{asset.friendlyName}</p>}
              </div>
            </div>
          </div>

          {this.renderLiveDetailRow("Depot:", depotName)}
          {this.renderLiveDetailRow("Address:", address)}
          {this.renderLiveDetailRow(liveStatusSinceDetail.label, liveStatusSinceDetail.value)}
          {this.renderLiveDetailRow("GPS Time:", gpsTimeDetail.value, {
            iconNode: <span className={`asset-health-dot ${pingHealth}`}></span>,
            meta: gpsTimeDetail.meta,
            className: "gps-time-detail-row"
          })}
          {this.renderLiveDetailRow("Speed:", speed !== undefined && speed !== null ? `${rounding(speed)} km/h` : "")}
          {this.renderLiveDetailRow("Heading:", getFriendlyHeading(heading))}
          {this.renderLiveDetailRow("GPS:", this.renderGpsDetailValue(message, latitude, longitude, satellites), { className: "gps-detail-row" })}
          {this.hasTemperatureData(message) && this.renderColdChainDetailRow(tempA, tempB, fridge)}
          {this.isDoorSensorAsset(asset) && this.renderDoorSensorDetailRow(doorSensor)}
          {this.renderDistanceDetailRow(trip, odometer)}
          {this.shouldShowDeviceVoltage(asset) && this.renderLiveDetailRow("Volts:", this.renderVoltageValue(volts), { className: this.isLowVoltage(volts) ? "volts-detail-row low-voltage" : "volts-detail-row" })}
          {this.renderLiveDetailRow("MessageID:", messageId)}

          <div className="live-refresh-meta">
            <span>Last refreshed: {utcToReportDate(new Date())}</span>
          </div>
        </section>

        {this.renderIncidentAlertCard()}{this.renderDriverStatusCard(asset)}
        {this.state.liveReportPosition === "bottom" && reportCard}
      </React.Fragment>
    );
  };

  renderAssetSettingsModalContent = (asset) => {
    if (!asset) return null;

    var message = this.getLastMessage(asset);
    var odometer = this.getMessageValue(message, ["odometer", "Odometer"]);
    var currentOdometer = this.state.assetCommandStatus && this.state.assetCommandStatus.currentOdometerKm !== null && this.state.assetCommandStatus.currentOdometerKm !== undefined
      ? this.state.assetCommandStatus.currentOdometerKm
      : odometer;
    var isOnline = this.state.assetCommandStatus && this.state.assetCommandStatus.isOnline === true;
    var commandStatusKnown = !this.state.assetCommandStatusLoading && this.state.assetCommandStatus !== null;
    var odometerKm = Number(this.state.odometerInputKm);
    var roundedOdometerKm = Number.isFinite(odometerKm) && odometerKm >= 0 ? Math.round(odometerKm) : "";
    var hasUserColourOverride = !!this.getUserAssetColourOverride(asset);
    var canUseColourOverride = this.canUseUserAssetColourOverride();

    return (
      <div className="admin-asset-modal-body">
        <section className="admin-asset-detail-card report-mode-setting-card">
          <div className="admin-card-title-row">
            <h4>Report Selection</h4>
          </div>
          <p>Choose how the Reports dropdown works in Live Asset Details.</p>
          <div className="report-mode-options" role="group" aria-label="Report selection mode">
            <button
              type="button"
              className={this.state.liveReportMode === "quick" ? "active" : ""}
              onClick={() => this.setLiveReportMode("quick")}
            >
              <strong>1-click</strong>
              <small>Select a report to open it immediately for today.</small>
            </button>
            <button
              type="button"
              className={this.state.liveReportMode === "expanded" ? "active" : ""}
              onClick={() => this.setLiveReportMode("expanded")}
            >
              <strong>Expanded</strong>
              <small>Select a report, optionally change the date, then press Open.</small>
            </button>
          </div>
        </section>

        <section className="admin-asset-detail-card report-mode-setting-card">
          <div className="admin-card-title-row">
            <h4>Report Tile Position</h4>
          </div>
          <p>Choose where Reports appears in the Live Asset Details column.</p>
          <div className="report-mode-options" role="group" aria-label="Report tile position">
            <button
              type="button"
              className={this.state.liveReportPosition === "top" ? "active" : ""}
              onClick={() => this.setLiveReportPosition("top")}
            >
              <strong>Top</strong>
              <small>Show Reports above the asset details.</small>
            </button>
            <button
              type="button"
              className={this.state.liveReportPosition === "bottom" ? "active" : ""}
              onClick={() => this.setLiveReportPosition("bottom")}
            >
              <strong>Bottom</strong>
              <small>Show Reports below the asset and driver details.</small>
            </button>
          </div>
        </section>

        <section className="admin-asset-detail-card asset-colour-command-card">
          <div className="admin-card-title-row">
            <h4>Icon Colour</h4>
            {hasUserColourOverride && <span className="asset-user-setting-pill">User override</span>}
          </div>
          {this.state.assetColourResult && (
            <div className={`admin-sms-result ${this.state.assetColourResult.type}`}>
              {this.state.assetColourResult.message}
            </div>
          )}
          <div className="asset-colour-control-row">
            <label className="admin-sms-field asset-colour-field">
              <span>My icon colour</span>
              <input
                type="color"
                value={this.normalizeColourValue(this.state.assetColourInput) || DEFAULT_REALTIME_VISUAL_COLOUR}
                onChange={this.handleAssetColourInputChange}
                disabled={!canUseColourOverride}
              />
            </label>
            <label className="admin-sms-field">
              <span>Hex colour</span>
              <input
                type="text"
                value={this.state.assetColourInput}
                onChange={this.handleAssetColourInputChange}
                placeholder="#2563eb"
                disabled={!canUseColourOverride}
              />
            </label>
          </div>
          <div className="asset-colour-command-footer">
            <span>
              {canUseColourOverride
                ? "Applies only to your realtime custom truck colour view."
                : "Switch realtime settings to Custom truck colours to use this override."}
            </span>
            <div className="asset-colour-actions">
              <button type="button" className="admin-sms-send-button secondary" onClick={() => this.clearAssetColourOverride(asset)} disabled={!hasUserColourOverride}>
                Reset
              </button>
              <button type="button" className="admin-sms-send-button" onClick={() => this.saveAssetColourOverride(asset)} disabled={!canUseColourOverride || !this.state.assetColourInput}>
                Save colour
              </button>
            </div>
          </div>
        </section>

        {this.canSetOdometerForSelectedAsset(asset) ? <section className="admin-asset-detail-card odometer-command-card">
          <div className="admin-card-title-row">
            <h4>Set Odometer</h4>
            <span className={isOnline ? "asset-online-indicator online" : "asset-online-indicator offline"}>
              <span></span>
              {this.state.assetCommandStatusLoading ? "Checking..." : isOnline ? "Online" : "Offline"}
            </span>
          </div>
          {this.state.odometerResult && (
            <div className={`admin-sms-result ${this.state.odometerResult.type}`}>
              {this.state.odometerResult.message}
            </div>
          )}
          <div className="odometer-command-grid">
            <label className="admin-sms-field odometer-readonly-field">
              <span>Current odometer</span>
              <input type="text" value={currentOdometer !== null && currentOdometer !== undefined && currentOdometer !== "" ? `${this.formatWholeKm(currentOdometer)} km` : "-"} readOnly />
            </label>
            <label className="admin-sms-field">
              <span>New odometer (km)</span>
              <input
                type="number"
                min="0"
                step="1"
                value={this.state.odometerInputKm}
                onChange={this.handleOdometerInputChange}
                disabled={this.state.odometerSubmitting || !isOnline}
              />
            </label>
          </div>
          <div className="odometer-command-footer">
            <span>{roundedOdometerKm !== "" ? `To update device km to ${roundedOdometerKm} km, press Set odometer to save.` : "Enter the new odometer reading in km."}</span>
            <button
              type="button"
              className="admin-sms-send-button odometer-send-button"
              onClick={() => this.submitOdometerUpdate(asset)}
              disabled={this.state.odometerSubmitting || this.state.assetCommandStatusLoading || !commandStatusKnown || !isOnline || !this.state.odometerInputKm}
            >
              {this.state.odometerSubmitting ? "Sending..." : "Set odometer"}
            </button>
          </div>
          {!this.state.assetCommandStatusLoading && !isOnline && (
            <p className="odometer-offline-note">Asset is offline in the DMC listener. Try again when it is online.</p>
          )}
          {this.renderOdometerProgressSteps()}
        </section> : (
          <section className="admin-asset-detail-card">
            <div className="admin-card-title-row">
              <h4>Device Settings</h4>
            </div>
            <p className="odometer-offline-note">No device command settings are available for this device model yet.</p>
          </section>
        )}
      </div>
    );
  };

  renderAdminAssetModalContent = (asset) => {
    if (!asset) return null;

    var imei = this.getValue(asset, ["imei", "IMEI", "Imei"]);
    var dmcUrl = imei ? `${WEB_DMC_DEVICE_BASE_URL}${encodeURIComponent(imei)}` : "";

    return (
      <div className="admin-asset-modal-body">
        <section className="admin-asset-summary">
          <div>
            <span className="admin-asset-kicker">Selected Asset</span>
            <h3>{asset.assetName || "-"}</h3>
            {asset.friendlyName && <p>{asset.friendlyName}</p>}
          </div>
            <span className={`asset-status-chip ${this.getAssetState(asset)}`}>{this.getAssetState(asset)}</span>
        </section>

        <section className="admin-asset-detail-card">
          <h4>Device Access</h4>
          <div className="admin-dmc-row">
            <div>
              <span>IMEI</span>
              <strong>{imei || "-"}</strong>
            </div>
            {dmcUrl ? (
              <a className="admin-dmc-link" href={dmcUrl} target="_blank" rel="noreferrer">
                Open Web DMC
              </a>
            ) : (
              <span className="admin-dmc-link disabled">Open Web DMC</span>
            )}
          </div>
        </section>

        <section className="admin-asset-detail-card admin-sms-card">
          <h4>SMS</h4>
          {this.state.adminSmsResult && (
            <div className={`admin-sms-result ${this.state.adminSmsResult.type}`}>
              {this.state.adminSmsResult.message}
            </div>
          )}
          <div className="admin-sms-thread-toolbar">
            <span>Messages</span>
            <button
              type="button"
              onClick={() => this.loadAdminSmsMessages(asset)}
              disabled={this.state.adminSmsMessagesLoading || !this.state.adminSmsDestinationNumber}
            >
              {this.state.adminSmsMessagesLoading ? "Refreshing..." : "Refresh responses"}
            </button>
          </div>
          <div className="admin-sms-thread" ref={this.adminSmsThreadRef}>
            {this.state.adminSmsMessages.length ? (
              this.state.adminSmsMessages.map((message) => (
                <div className={`admin-sms-bubble ${message.direction}`} key={message.id || `${message.created}-${message.content}`}>
                  <p>{message.content}</p>
                  <span>{this.formatAdminSmsTime(message.created)}</span>
                </div>
              ))
            ) : (
              <div className="admin-sms-empty">No SMS messages in this session.</div>
            )}
          </div>
          <label className="admin-sms-field">
            <span>Mobile number</span>
            <input
              type="text"
              value={this.state.adminSmsDestinationNumber}
              onChange={this.handleAdminSmsDestinationChange}
              disabled={this.state.adminSmsSending}
              placeholder="+61412345678"
            />
          </label>
          <div className="admin-sms-presets">
            {this.state.adminSmsPresets.map((preset, index) => (
              <button
                type="button"
                key={`sms-preset-${index}`}
                onClick={() => this.applyAdminSmsPreset(preset.command)}
                disabled={!preset.command || this.state.adminSmsSending || this.state.adminSmsPresetLoading}
              >
                {preset.label}
              </button>
            ))}
            <button type="button" className="admin-sms-edit-presets-button" onClick={this.toggleAdminSmsPresetEditor}>
              {this.state.adminSmsPresetEditorOpen ? "Hide editor" : "Edit buttons"}
            </button>
          </div>
          {this.state.adminSmsPresetEditorOpen && (
            <div className="admin-sms-preset-editor">
              <div className="admin-sms-preset-editor-header">
                <strong>Global SMS buttons</strong>
                <span>Saved labels and commands are shared by all staff.</span>
              </div>
              {this.state.adminSmsPresets.map((preset, index) => (
                <div className="admin-sms-preset-editor-row" key={`sms-preset-editor-${index}`}>
                  <label>
                    <span>Button {index + 1} label</span>
                    <input
                      type="text"
                      value={preset.label}
                      onChange={(event) => this.updateAdminSmsPreset(index, "label", event.target.value)}
                    />
                  </label>
                  <label>
                    <span>Command</span>
                    <input
                      type="text"
                      value={preset.command}
                      onChange={(event) => this.updateAdminSmsPreset(index, "command", event.target.value)}
                    />
                  </label>
                </div>
              ))}
              <button
                type="button"
                className="admin-sms-save-presets-button"
                onClick={this.saveAdminSmsPresets}
                disabled={this.state.adminSmsPresetSaving}
              >
                {this.state.adminSmsPresetSaving ? "Saving..." : "Save buttons"}
              </button>
            </div>
          )}
          <label className="admin-sms-field">
            <span>Message</span>
            <textarea
              rows="4"
              value={this.state.adminSmsContent}
              onChange={this.handleAdminSmsContentChange}
              disabled={this.state.adminSmsSending}
              maxLength="5000"
            />
          </label>
          <button
            type="button"
            className="admin-sms-send-button"
            onClick={() => this.sendAdminSms(asset)}
            disabled={this.state.adminSmsSending || !this.state.adminSmsDestinationNumber || !this.state.adminSmsContent}
          >
            {this.state.adminSmsSending ? "Sending..." : "Send SMS"}
          </button>
        </section>
      </div>
    );
  };

  renderRealtimeListView = (assets, selectedAsset, activeAssets, drivingAssets, parkedAssets, trackerAssets, dashcamAssets) => {
    const reportDate = getLocalCalendarDate();
    const showFriendlyNameColumn = assets.some((asset) => !!String(asset.friendlyName || "").trim());
    const showDoorSensorColumn = assets.some((asset) => this.isDoorSensorAsset(asset));
    const columnCount = 15 + (showFriendlyNameColumn ? 1 : 0) + (showDoorSensorColumn ? 1 : 0);

    return (
      <section className="realtime-list-panel">
        <div className="realtime-list-header">
          <div>
            <h2>Realtime Asset List</h2>
          </div>
          <div className="realtime-list-refresh-status">
            Last refreshed {this.formatRealtimeListLastRefreshed()}
          </div>
          <div className="realtime-list-header-actions">
            <div className="asset-search-row list-search-row">
              <input
                value={this.state.assetSearch}
                onChange={this.handleSearchChange}
                placeholder="Search assets..."
              />
              <button type="button" onClick={this.clearSearch}>Clear</button>
            </div>
            {this.renderInlineAssetFilters(activeAssets, drivingAssets, parkedAssets, trackerAssets, dashcamAssets)}
          </div>
        </div>

        <div className="realtime-list-table-wrap">
          <table className="realtime-list-table">
            <thead>
              <tr>
                <th className="icon-column"></th>
                <th>Last Ping</th>
                {showFriendlyNameColumn && <th>Friendly Name</th>}
                <th>Name</th>
                <th>Location</th>
                <th>GPS</th>
                <th>Engine</th>
                <th>Speed</th>
                <th>Direction</th>
                <th>Fridge</th>
                <th>Temp A</th>
                <th>Temp B</th>
                {showDoorSensorColumn && <th>Door</th>}
                <th>Status</th>
                <th>Volts</th>
                <th>Odometer</th>
                <th>Reports</th>
              </tr>
            </thead>
            <tbody>
              {assets.map((asset) => {
                var lastMessage = this.getLastMessage(asset);
                var gprmc = this.getGprmc(lastMessage);
                var state = this.getAssetState(asset);
                var isSelected = selectedAsset && selectedAsset.assetId === asset.assetId;
                var latitude = this.getGprmcValue(gprmc, ["latitude", "Latitude", "lat", "Lat"]);
                var longitude = this.getGprmcValue(gprmc, ["longitude", "Longitude", "lng", "Lng", "lon", "Lon"]);
                var speed = this.getGprmcValue(gprmc, ["speed", "Speed"]);
                var heading = this.getGprmcValue(gprmc, ["heading", "Heading"]);
                var gpsLocked = this.isGpsLocked(lastMessage);
                var fridge = this.getMessageValue(lastMessage, ["iO1", "IO1", "io1"]);
                var doorSensor = this.getMessageValue(lastMessage, ["iO2", "IO2", "io2"]);
                var tempA = this.getMessageValue(lastMessage, ["sensorAValue", "SensorAValue"]);
                var tempB = this.getMessageValue(lastMessage, ["sensorBValue", "SensorBValue"]);
                var volts = this.getMessageValue(lastMessage, ["deviceVolts", "DeviceVolts"]);
                var isLowVoltage = this.isLowVoltage(volts);
                var odometer = this.getMessageValue(lastMessage, ["odometer", "Odometer"]);
                var health = this.getPingHealth(asset);
                var address = this.getListAddress(asset);
                var addressSource = this.getListAddressSource(asset);
                var addressKey = this.getAddressKey(asset);
                var assetVisual = this.getAssetRealtimeListVisual(asset);
                var isAddressLoading =
                  ENABLE_REALTIME_LIST_ADDRESS_LOOKUP &&
                  !address &&
                  addressKey &&
                  this.state.listAddressBatchKey.indexOf(addressKey) !== -1;

                return (
                  <tr
                    key={asset.assetId}
                    className={isSelected ? `selected ${state}` : state}
                    onClick={() => this.handleAssetSelect(asset)}
                  >
                    <td className="asset-icon-cell">
                      <button
                        type="button"
                        className="asset-map-open-button"
                        title={`Show ${asset.assetName} on map`}
                        onClick={(event) => this.handleListAssetMapClick(event, asset)}
                      >
                        <span style={assetVisual.colour ? { color: assetVisual.colour } : null}>
                          {assetVisual.useOriginalTruck ? this.renderOriginalTruckIcon() : <i className={this.getSafeIconClass(assetVisual.icon)}></i>}
                        </span>
                      </button>
                    </td>
                    <td className="ping-time-cell" title={this.getTimestampTitle(lastMessage)}>{utcToReportDate(this.getMessageCreatedTimestamp(lastMessage)) || "-"}</td>
                    {showFriendlyNameColumn && <td>{asset.friendlyName || "-"}</td>}
                    <td className="asset-name-cell">
                      <span className="asset-name-with-health">
                        <span className={`asset-health-dot ${health}`}></span>
                        <a href={`/Track?assetId=${asset.assetId}&assetName=${asset.assetName}`} target="_blank" rel="noreferrer" onClick={(event) => event.stopPropagation()}>
                          {asset.assetName}
                        </a>
                        {canAccessVideo() && this.isDashcamAsset(asset) && <button type="button" className={`realtime-video-button realtime-video-button-${this.getVideoCameraStatus(asset)}`} title={`Video for ${asset.assetName} — camera ${this.getVideoCameraStatus(asset)}`} aria-label={`Video for ${asset.assetName} — camera ${this.getVideoCameraStatus(asset)}`} onClick={event => { event.stopPropagation(); this.setState({ videoAsset: asset }); }}><i className="fa fa-video-camera" aria-hidden="true"></i></button>}
                      </span>
                      {asset.iButtonName && <small>{asset.iButtonName}</small>}
                    </td>
                    <td className="location-cell">
                      <span>
                        {this.shouldShowAddressSourceIndicators() && addressSource && (
                          <span
                            className={`address-source-dot ${this.isHereAddressSource(addressSource) ? "source-here" : "source-cache"}`}
                            title={this.getAddressSourceLabel(addressSource)}
                          ></span>
                        )}
                        {address || (isAddressLoading ? "Translating address..." : "-")}
                      </span>
                      {latitude && longitude && (
                        <a
                          href={`https://www.google.com/maps?q=${latitude},${longitude}`}
                          target="_blank"
                          rel="noreferrer"
                          onClick={(event) => event.stopPropagation()}
                        >
                          <i className="fa fa-map-marker"></i> Map
                        </a>
                      )}
                    </td>
                    <td>
                      <span className={gpsLocked ? "gps-pill gps-pill-online" : "gps-pill gps-pill-offline"} title={gpsLocked ? "GPS Lock" : "No GPS Lock"}>
                        <i className="fa fa-globe"></i> {gpsLocked ? "Lock" : "No lock"}
                      </span>
                    </td>
                    <td>
                      <span className="engine-state">
                        <span className={state === "driving" ? "engine-driving" : "engine-park"}>{state === "driving" ? "D" : "P"}</span>
                        {asset.lastStatusChange ? this.formatStatusAge(asset.lastStatusChange) : "-"}
                      </span>
                    </td>
                    <td>{this.formatListSpeed(speed) || "-"}</td>
                    <td>{getFriendlyHeading(heading) || "-"}</td>
                    <td>{this.renderFridgePill(fridge)}</td>
                    <td>{tempA !== null && tempA !== undefined && tempA !== "" ? tempA : "-"}</td>
                    <td>{tempB !== null && tempB !== undefined && tempB !== "" ? tempB : "-"}</td>
                    {showDoorSensorColumn && <td>{this.isDoorSensorAsset(asset) ? this.renderDoorSensorPill(doorSensor) : "-"}</td>}
                    <td><span className={`asset-status-chip ${this.getAssetStatusClass(asset)}`}>{asset.statusString || state}</span></td>
                    <td className={isLowVoltage ? "volts-cell low-voltage" : "volts-cell"}>
                      {this.formatVolts(volts) ? (
                        <span>
                          {isLowVoltage && <span className="voltage-warning-icon" title="Low voltage">⚠️</span>}
                          {this.formatVolts(volts)}
                        </span>
                      ) : "-"}
                    </td>
                    <td>{odometer !== null && odometer !== undefined && odometer !== "" ? this.formatOdometer(odometer) : "-"}</td>
                    <td className="reports-cell">
                      <div className="list-report-menu" onClick={(event) => event.stopPropagation()}>
                        <button type="button" onClick={(event) => this.toggleReportMenu(event, asset.assetId)}>
                          Reports <i className="fa fa-angle-down"></i>
                        </button>
                        {this.state.openReportAssetId === asset.assetId && (
                          <div className={this.state.reportMenuDirection === "up" ? "list-report-dropdown drop-up" : "list-report-dropdown"}>
                            <button type="button" onClick={(event) => this.openLiveReport(event, asset, reportDate, "/Rpt-MVTL")}>MVTL</button>
                            <button type="button" onClick={(event) => this.openLiveReport(event, asset, reportDate, "/Rpt-Visit")}>Visit Report</button>
                            <button type="button" onClick={(event) => this.openLiveReport(event, asset, reportDate, "/Temperature")}>Temperature</button>
                            <button type="button" onClick={(event) => this.openLiveReport(event, asset, reportDate, "/Replay")}>Replay</button>
                            <button type="button" onClick={(event) => this.openLiveReport(event, asset, reportDate, "/Rpt-LocationData")}>Location</button>
                            <button type="button" onClick={(event) => this.openLiveReport(event, asset, reportDate, "/Timeline")}>Timeline</button>
                            <button type="button" onClick={(event) => this.openLiveReport(event, asset, reportDate, "/Track")}>Track</button>
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                );
              })}
              {!assets.length && (
                <tr>
                  <td colSpan={columnCount} className="realtime-list-empty">No assets match this filter.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </section>
    );
  };

  renderGroupFilterTile = (activeAssets, realTimeGroups) => (
    <section className="realtime-filter-tile group-control-tile">
      <div className="filter-label filter-label-row">
        <strong>{activeAssets.length} assets</strong>
      </div>
      <select
        className="group-filter-select"
        value={this.props.realTimeGroupId || ""}
        onChange={this.handleGroupSelection}
      >
        {realTimeGroups.length > 0 ? (
          realTimeGroups.map((element) => {
            var groupName = `${element.customername} - ${element.groupName}`;
            return (
              <option
                key={element.groupId}
                value={element.groupId}
                data-group-name={groupName}
              >
                {groupName}
              </option>
            );
          })
        ) : (
          <option value="">No groups assigned</option>
        )}
      </select>
    </section>
  );

  renderRealtimeModeControls = () => (
    <section className="realtime-filter-tile realtime-mode-controls-tile">
      <span className="view-toggle" role="group" aria-label="Realtime view mode">
        <button
          type="button"
          className={this.state.realtimeViewMode === "map" ? "active" : ""}
          onClick={() => this.setRealtimeViewMode("map")}
        >
          Map
        </button>
        <button
          type="button"
          className={this.state.realtimeViewMode === "list" ? "active" : ""}
          onClick={() => this.setRealtimeViewMode("list")}
        >
          List
        </button>
      </span>
      {canAccessVideo() && this.state.hasVideoUsage && <button type="button" className="theme-toggle video-usage-shortcut" onClick={() => this.setState({ videoUsageOpen: true })}>My video usage</button>}
      {this.isSystemAdmin() ? (
        <React.Fragment>
          <button type="button" className="theme-toggle" onClick={this.toggleTheme}>
            {this.state.realtimeTheme === "dark" ? "Light" : "Dark"}
          </button>
          <button type="button" className={this.state.devPanelOpen ? "theme-toggle dev-toggle active" : "theme-toggle dev-toggle"} onClick={this.toggleDevPanel}>
            DEV
          </button>
        </React.Fragment>
      ) : null}
      <button type="button" className="theme-toggle realtime-user-settings-toggle" onClick={this.openUserSettings} title="Map settings" aria-label="Map settings">
        <i className="fa fa-cog" aria-hidden="true"></i>
      </button>
    </section>
  );

  renderUserSettingsModalContent = () => (
    <div className="realtime-user-settings-panel">
      <section className="realtime-settings-section">
        <div className="realtime-settings-copy">
          <span>List view map</span>
          <small>Show the live fleet map above the Realtime Asset List. This setting applies only to your List view.</small>
        </div>
        <div className="realtime-settings-segment" role="group" aria-label="List view map">
          <button
            type="button"
            className={!this.state.listMapEnabled ? "active" : ""}
            onClick={() => this.setListMapEnabled(false)}
          >
            List only
          </button>
          <button
            type="button"
            className={this.state.listMapEnabled ? "active" : ""}
            onClick={() => this.setListMapEnabled(true)}
          >
            Map + list
          </button>
        </div>
        {this.state.listMapEnabled && (
          <div className="realtime-list-map-height-options" role="group" aria-label="List map height">
            {[
              { key: "half", label: "Half page", detail: "50%" },
              { key: "tall", label: "Tall", detail: "60%" },
              { key: "extraTall", label: "Extra tall", detail: "70%" },
            ].map((option) => (
              <button
                type="button"
                key={option.key}
                className={this.state.listMapHeight === option.key ? "active" : ""}
                onClick={() => this.setListMapHeight(option.key)}
              >
                <strong>{option.label}</strong>
                <small>{option.detail} of the screen</small>
              </button>
            ))}
          </div>
        )}
      </section>

      <section className="realtime-settings-section">
        <div className="realtime-settings-copy">
          <span>Map display</span>
          <small>Choose the map surface and surrounding realtime panels.</small>
        </div>
        <div className="realtime-settings-segment" role="group" aria-label="Display mode">
          {[
            { key: "light", label: "Light" },
            { key: "dark", label: "Dark" },
          ].map((theme) => (
            <button
              type="button"
              key={theme.key}
              className={this.state.realtimeTheme === theme.key ? "active" : ""}
              onClick={() => {
                localStorage.setItem("realtimeTheme", theme.key);
                this.setState({ realtimeTheme: theme.key });
              }}
            >
              {theme.label}
            </button>
          ))}
        </div>
      </section>

      <section className="realtime-settings-section">
        <div className="realtime-settings-copy">
          <span>Truck colours</span>
          <small>Choose how trucks are coloured on the map and asset views.</small>
        </div>
        <div className="realtime-visual-options">
          {this.getCustomerVisualModes().map((mode) => (
            <button
              type="button"
              key={mode.key}
              className={this.state.realtimeVisualMode === mode.key ? "active" : ""}
              onClick={() => this.setRealtimeVisualMode(mode.key)}
            >
              <strong>{mode.title}</strong>
              <small>{mode.description}</small>
            </button>
          ))}
        </div>
      </section>
    </div>
  );

  renderPanelFilterButton = (filter, activeKey, onClick, classPrefix) => (
    <button
      type="button"
      key={filter.key}
      className={activeKey === filter.key ? `panel-filter-button active ${classPrefix}-${filter.key}` : `panel-filter-button ${classPrefix}-${filter.key}`}
      onClick={() => onClick(filter.key)}
    >
      <span>{filter.label}</span>
      {filter.count !== undefined && <strong>{filter.count}</strong>}
    </button>
  );

  renderAssetPanelFilterCard = (activeAssets, drivingAssets, parkedAssets, trackerAssets, dashcamAssets) => (
    <div className="asset-filter-card asset-panel-filter-card">
      <div className="panel-filter-section">
        <span>Status Filter</span>
        <div className="panel-filter-buttons status-panel-buttons">
          {[
            { key: "all", label: "All", count: activeAssets.length },
            { key: "driving", label: "Driving", count: drivingAssets },
            { key: "parked", label: "Parked", count: parkedAssets },
          ].map((filter) => this.renderPanelFilterButton(filter, this.state.assetFilter, this.handleFilterChange, "status"))}
        </div>
      </div>
      <div className="panel-filter-section">
        <span>Type Filter</span>
        <div className="panel-filter-buttons type-panel-buttons">
          {[
            { key: "all", label: "All", count: activeAssets.length },
            { key: "trackers", label: "Trackers", count: trackerAssets },
            { key: "dashcams", label: "Cameras", count: dashcamAssets },
          ].map((filter) => this.renderPanelFilterButton(filter, this.state.assetTypeFilter, this.handleTypeFilterChange, "type"))}
        </div>
      </div>
      <div className="asset-search-row panel-search-row">
        <input
          value={this.state.assetSearch}
          onChange={this.handleSearchChange}
          placeholder="Search assets..."
        />
        <button type="button" onClick={this.clearSearch}>Clear</button>
      </div>
    </div>
  );

  renderInlineAssetFilters = (activeAssets, drivingAssets, parkedAssets, trackerAssets, dashcamAssets) => (
    <div className="inline-asset-filters">
      <div className="inline-filter-group" aria-label="Ignition status filter">
        {[
          { key: "all", label: "All", count: activeAssets.length },
          { key: "driving", label: "Driving", count: drivingAssets },
          { key: "parked", label: "Parked", count: parkedAssets },
        ].map((filter) => this.renderPanelFilterButton(filter, this.state.assetFilter, this.handleFilterChange, "status"))}
      </div>
      <div className="inline-filter-group" aria-label="Asset type filter">
        {[
          { key: "all", label: "All", count: activeAssets.length },
          { key: "trackers", label: "Trackers", count: trackerAssets },
          { key: "dashcams", label: "Cameras", count: dashcamAssets },
        ].map((filter) => this.renderPanelFilterButton(filter, this.state.assetTypeFilter, this.handleTypeFilterChange, "type"))}
      </div>
    </div>
  );

  renderFullscreenMapFilters = (activeAssets, drivingAssets, parkedAssets, trackerAssets, dashcamAssets) => (
    <div className="fullscreen-map-filter-content">
      <div className="panel-filter-section">
        <span>Status Filter</span>
        <div className="panel-filter-buttons status-panel-buttons">
          {[
            { key: "all", label: "All", count: activeAssets.length },
            { key: "driving", label: "Driving", count: drivingAssets },
            { key: "parked", label: "Parked", count: parkedAssets },
          ].map((filter) => this.renderPanelFilterButton(filter, this.state.assetFilter, this.handleFilterChange, "status"))}
        </div>
      </div>
      <div className="panel-filter-section">
        <span>Type Filter</span>
        <div className="panel-filter-buttons type-panel-buttons">
          {[
            { key: "all", label: "All", count: activeAssets.length },
            { key: "trackers", label: "Trackers", count: trackerAssets },
            { key: "dashcams", label: "Cameras", count: dashcamAssets },
          ].map((filter) => this.renderPanelFilterButton(filter, this.state.assetTypeFilter, this.handleTypeFilterChange, "type"))}
        </div>
      </div>
      <div className="asset-search-row fullscreen-filter-search-row">
        <input
          value={this.state.assetSearch}
          onChange={this.handleSearchChange}
          placeholder="Search assets..."
        />
        <button type="button" onClick={this.clearSearch}>Clear</button>
      </div>
    </div>
  );

  renderStatusFilterTile = (activeAssets, drivingAssets, parkedAssets) => (
    <section className="realtime-filter-tile list-filter-tile">
      <div className="map-filter-group list-filter-group" aria-label="Ignition status filter">
        {[
          { key: "all", label: "All", shortLabel: "A", icon: "fa fa-circle", count: activeAssets.length },
          { key: "driving", label: "Driving", shortLabel: "D", icon: "fa fa-play", count: drivingAssets },
          { key: "parked", label: "Parked", shortLabel: "P", icon: "fa fa-square", count: parkedAssets },
        ].map((filter) => (
          <button
            type="button"
            key={filter.key}
            className={this.state.assetFilter === filter.key ? `map-filter-button list-filter-button active status-${filter.key}` : `map-filter-button list-filter-button status-${filter.key}`}
            onClick={() => this.handleFilterChange(filter.key)}
            title={filter.label}
          >
            <span className="map-filter-symbol">
              <i className={filter.icon} aria-hidden="true"></i>
              {filter.shortLabel}
            </span>
            <span className="map-filter-label">{filter.label}</span>
            <strong>{filter.count}</strong>
          </button>
        ))}
      </div>
    </section>
  );

  renderTypeFilterTile = (activeAssets, trackerAssets, dashcamAssets) => (
    <section className="realtime-filter-tile list-filter-tile">
      <div className="map-filter-group list-filter-group" aria-label="Asset type filter">
        {[
          { key: "all", label: "All", shortLabel: "A", icon: "fa fa-th-large", count: activeAssets.length },
          { key: "trackers", label: "Tracker", shortLabel: "T", icon: "fa fa-truck", count: trackerAssets },
          { key: "dashcams", label: "Camera", shortLabel: "C", icon: "fa fa-video-camera", count: dashcamAssets },
        ].map((filter) => (
          <button
            type="button"
            key={filter.key}
            className={this.state.assetTypeFilter === filter.key ? `map-filter-button list-filter-button active type-${filter.key}` : `map-filter-button list-filter-button type-${filter.key}`}
            onClick={() => this.handleTypeFilterChange(filter.key)}
            title={filter.label}
          >
            <span className="map-filter-symbol">
              <i className={filter.icon} aria-hidden="true"></i>
              {filter.shortLabel}
            </span>
            <span className="map-filter-label">{filter.label}</span>
            <strong>{filter.count}</strong>
          </button>
        ))}
      </div>
    </section>
  );

  renderCompactFilterControls = (activeAssets, drivingAssets, parkedAssets, trackerAssets, dashcamAssets) => (
    <div className="compact-filter-controls">
      <div className="map-filter-group" aria-label="Ignition status filter">
        {[
          { key: "all", label: "All ignition states", shortLabel: "A", icon: "fa fa-circle", count: activeAssets.length },
          { key: "driving", label: "Driving", shortLabel: "D", icon: "fa fa-play", count: drivingAssets },
          { key: "parked", label: "Parked", shortLabel: "P", icon: "fa fa-square", count: parkedAssets },
        ].map((filter) => (
          <button
            type="button"
            key={filter.key}
            className={this.state.assetFilter === filter.key ? `map-filter-button active status-${filter.key}` : `map-filter-button status-${filter.key}`}
            onClick={() => this.handleFilterChange(filter.key)}
            title={filter.label}
          >
            <span className="map-filter-symbol">
              <i className={filter.icon} aria-hidden="true"></i>
              {filter.shortLabel}
            </span>
            <strong>{filter.count}</strong>
          </button>
        ))}
      </div>
      <div className="map-filter-group" aria-label="Asset type filter">
        {[
          { key: "all", label: "All asset types", shortLabel: "A", icon: "fa fa-th-large", count: activeAssets.length },
          { key: "trackers", label: "Trackers", shortLabel: "T", icon: "fa fa-truck", count: trackerAssets },
          { key: "dashcams", label: "Cameras", shortLabel: "C", icon: "fa fa-video-camera", count: dashcamAssets },
        ].map((filter) => (
          <button
            type="button"
            key={filter.key}
            className={this.state.assetTypeFilter === filter.key ? `map-filter-button active type-${filter.key}` : `map-filter-button type-${filter.key}`}
            onClick={() => this.handleTypeFilterChange(filter.key)}
            title={filter.label}
          >
            <span className="map-filter-symbol">
              <i className={filter.icon} aria-hidden="true"></i>
              {filter.shortLabel}
            </span>
            <strong>{filter.count}</strong>
          </button>
        ))}
      </div>
    </div>
  );

  renderRealtimeFilterStrip = (
    activeAssets,
    realTimeGroups,
    extraClassName = "",
  ) => (
    <div className={[
      "realtime-filter-strip",
      extraClassName,
    ].filter(Boolean).join(" ")}>
      {this.renderGroupFilterTile(activeAssets, realTimeGroups)}
      {this.renderRealtimeModeControls()}
    </div>
  );

  render() {
    let defaultGroup =
      this.state.listgroup && this.state.listgroup.groupName ? this.state.listgroup.groupName + "-" + this.state.listgroup.customername : "";
    const { realTimeData, mapChange, singleTruckZoom, followTruckPosition, dataLoading } = this.state;
    const activeAssets = this.getActiveAssets(realTimeData);
    const drivingAssets = activeAssets.filter((asset) => this.getAssetState(asset) === "driving").length;
    const parkedAssets = activeAssets.filter((asset) => this.getAssetState(asset) === "parked").length;
    const dashcamAssets = activeAssets.filter((asset) => this.isDashcamAsset(asset)).length;
    const trackerAssets = activeAssets.length - dashcamAssets;
    const filteredAssets = this.filterAssetList(activeAssets);
    const trimmedAssetSearch = this.state.assetSearch.trim();
    const mapAssets = (trimmedAssetSearch ? filteredAssets : this.filterAssets(activeAssets)).map((asset) => this.applyUserAssetColourOverride(asset));
    const mapChangeWithOverrides = this.getMapChangeWithUserAssetColourOverrides(mapChange);
    const mapFitBoundsKey = [
      this.state.assetFilter,
      this.state.assetTypeFilter,
      trimmedAssetSearch.toLowerCase(),
    ].join("|");
    const selectedAsset = this.getSelectedAsset(activeAssets);
    const selectedMessage = selectedAsset ? this.getLastMessage(selectedAsset) : {};
    const selectedGprmc = this.getGprmc(selectedMessage);
    const selectedHeading = this.getGprmcValue(selectedGprmc, ["heading", "Heading"]);
    const reportDate = getLocalCalendarDate();
    const currentGroup = this.state.groupName ? this.state.groupName : defaultGroup;
    const realTimeGroups = this.state.realTimeGroups.length ? this.state.realTimeGroups : this.props.realTimeGroup || [];
    const modalAsset = activeAssets.find((asset) => String(asset.assetId) === String(this.state.mapModalAssetId));

    return (
      <React.Fragment>
        {canAccessVideo() && this.state.videoAsset && <VideoPanel key={this.state.videoAsset.assetId} asset={this.state.videoAsset} onClose={() => { this.setState({ videoAsset: null }); this.loadVideoUsageAvailability(); }} />}
        {canAccessVideo() && this.state.videoUsageOpen && <VideoUsage own onClose={() => this.setState({ videoUsageOpen: false })} />}
        <Layout customGroups={true}>
          <Helmet>
            <title>RealTime</title>
          </Helmet>
          <div className="contentBody">
            <div className="contentWrapper">
              <div className={`real-time-page ${this.state.realtimeTheme}`}>
                {!this.state.incidentModalOpen && this.state.incidentActionMessage && <div role="status" className="alert alert-info">{this.state.incidentActionMessage}</div>}
                {this.state.incidentLinkMessage && <div role="status" className="alert alert-info">{this.state.incidentLinkMessage}</div>}
                {realTimeData.length > 0 && !dataLoading ? (
                  <div
                    className={[
                      "realtime-shell",
                      this.state.realtimeViewMode === "list" ? "list-mode" : "",
                      this.state.realtimeViewMode === "list" && this.state.listMapEnabled ? `list-map-enabled list-map-height-${this.state.listMapHeight}` : "",
                    ].filter(Boolean).join(" ")}
                  >
                    <aside className={this.state.realtimeViewMode === "list" ? "asset-monitor-panel list-monitor-panel" : "asset-monitor-panel"}>
                      <div className="asset-monitor-header">
                        <div className="panel-title asset-monitor-title">
                          <span>Realtime - Fleet Monitor</span>
                        </div>
                        <div className="panel-actions asset-monitor-actions">
                          <span className="live-pill">Live</span>
                        </div>
                      </div>

                      {this.state.realtimeViewMode === "map" && this.renderAssetPanelFilterCard(activeAssets, drivingAssets, parkedAssets, trackerAssets, dashcamAssets)}

                      {this.state.realtimeViewMode === "map" && <div className="asset-list">
                        {filteredAssets.map((asset) => {
                          var state = this.getAssetState(asset);
                          var health = this.getPingHealth(asset);
                          var isSelected = selectedAsset && selectedAsset.assetId === asset.assetId;
                          var assetSubLabel = asset.friendlyName || this.getValue(this.getLastMessage(asset), ["location", "Location", "address", "Address"]);
                          var assetVisual = this.getAssetRealtimeListVisual(asset);

                          return (
                            <button
                              type="button"
                              className={isSelected ? `asset-list-row selected ${state}` : `asset-list-row ${state}`}
                              key={asset.assetId}
                              onClick={() => this.handleAssetSelect(asset)}
                            >
                              <span
                                className={assetVisual.useOriginalTruck ? "asset-list-visual-icon original-truck-mode" : "asset-list-visual-icon"}
                                style={assetVisual.colour ? (assetVisual.useOriginalTruck ? { color: assetVisual.colour } : { backgroundColor: assetVisual.colour }) : null}
                              >
                                {assetVisual.useOriginalTruck ? this.renderOriginalTruckIcon() : <i className={this.getSafeIconClass(assetVisual.icon)}></i>}
                              </span>
                              <span className="asset-list-main">
                                <strong>{asset.assetName}</strong>
                                {assetSubLabel && <small>{assetSubLabel}</small>}
                              </span>
                              <span className="asset-status-wrap">
                                <span className={`asset-health-dot ${health}`}></span>
                                <span className={`asset-status-chip ${state}`}>{state}</span>
                              </span>
                            </button>
                          );
                        })}

                        {!filteredAssets.length && (
                          <div className="asset-list-empty">No assets match this filter.</div>
                        )}
                      </div>}
                    </aside>

                    <main className={this.state.realtimeViewMode === "list" ? "map-workspace-panel list-workspace-panel" : "map-workspace-panel"}>
                      {this.renderRealtimeFilterStrip(
                        activeAssets,
                        realTimeGroups,
                        ""
                      )}

                      {this.state.realtimeViewMode === "list" ? (
                        <React.Fragment>
                          {this.state.listMapEnabled && (
                            <section className="realtime-list-map-panel real-map-panel" ref={this.listMapRef}>
                              <RealMap
                                mapChange={mapChangeWithOverrides}
                                singleTruckZoom={singleTruckZoom}
                                followTruckPosition={followTruckPosition}
                                realTimeData={mapAssets}
                                fitBoundsKey={mapFitBoundsKey}
                                fitFilteredAssets={!!trimmedAssetSearch}
                                isFullScreen={this.state.isFullScreen}
                                scrollLockEnabled={this.state.scrollLockEnabled}
                                clusteringEnabled={this.state.mapClusteringEnabled}
                                visualMode={this.state.realtimeVisualMode}
                                selectedAssetId={selectedAsset && selectedAsset.assetId}
                                showMapControls
                                headingLabel={selectedAsset ? `Heading: ${getFriendlyHeading(selectedHeading) || "Unknown"}` : "Select an asset"}
                                fullscreenFilterContent={this.renderFullscreenMapFilters(activeAssets, drivingAssets, parkedAssets, trackerAssets, dashcamAssets)}
                                showDriverOverlay={!!selectedAsset && (!!this.renderDriverStatusCard(selectedAsset) || this.state.driverIncidents.length > 0 || this.state.driverIncidentsFailed)}
                                driverOverlayLabel={selectedAsset ? `${selectedAsset.assetName} driver and incidents` : undefined}
                                fullscreenDriverContent={<>{this.renderIncidentAlertCard("fullscreen-driver-status-card")}{this.renderDriverStatusCard(selectedAsset, "fullscreen-driver-status-card")}</>}
                                mapOverlayContent={this.renderErpStopsOverlay()}
                                mapOverlayMinimized={this.state.erpStopsPanelHidden}
                                erpGeofences={this.state.erpGeofencesVisible ? this.state.erpGeofences : []}
                                erpProgress={this.state.erpProgress}
                                followSelectedAsset={this.state.followSelectedAsset}
                                scrollToTopOnSelection={false}
                                onFullscreenToggle={this.handleFullScreen}
                                onScrollLockToggle={this.toggleScrollLock}
                                onFollowSelectedToggle={this.toggleFollowSelectedAsset}
                                onClusteringToggle={this.toggleMapClustering}
                                onClearSelectedAsset={this.clearSelectedAsset}
                                onAssetSelection={this.handleMapAssetSelection}
                                onUserMove={this.handleMapUserMove}
                              />
                            </section>
                          )}
                          {this.renderRealtimeListView(filteredAssets, selectedAsset, activeAssets, drivingAssets, parkedAssets, trackerAssets, dashcamAssets)}
                        </React.Fragment>
                      ) : (
                        <section className="real-map-panel">
                          <RealMap
                            mapChange={mapChangeWithOverrides}
                            singleTruckZoom={singleTruckZoom}
                            followTruckPosition={followTruckPosition}
                            realTimeData={mapAssets}
                            fitBoundsKey={mapFitBoundsKey}
                            fitFilteredAssets={!!trimmedAssetSearch}
                            isFullScreen={this.state.isFullScreen}
                            scrollLockEnabled={this.state.scrollLockEnabled}
                            clusteringEnabled={this.state.mapClusteringEnabled}
                            visualMode={this.state.realtimeVisualMode}
                            selectedAssetId={selectedAsset && selectedAsset.assetId}
                            showMapControls
                            headingLabel={selectedAsset ? `Heading: ${getFriendlyHeading(selectedHeading) || "Unknown"}` : "Select an asset"}
                            fullscreenFilterContent={this.renderFullscreenMapFilters(activeAssets, drivingAssets, parkedAssets, trackerAssets, dashcamAssets)}
                            fullscreenDriverContent={<>{this.renderIncidentAlertCard("fullscreen-driver-status-card")}{this.renderDriverStatusCard(selectedAsset, "fullscreen-driver-status-card")}</>}
                            mapOverlayContent={this.renderErpStopsOverlay()}
                            mapOverlayMinimized={this.state.erpStopsPanelHidden}
                            erpGeofences={this.state.erpGeofencesVisible ? this.state.erpGeofences : []}
                            erpProgress={this.state.erpProgress}
                            followSelectedAsset={this.state.followSelectedAsset}
                            onFullscreenToggle={this.handleFullScreen}
                            onScrollLockToggle={this.toggleScrollLock}
                            onFollowSelectedToggle={this.toggleFollowSelectedAsset}
                            onClusteringToggle={this.toggleMapClustering}
                            onClearSelectedAsset={this.clearSelectedAsset}
                            onAssetSelection={this.handleMapAssetSelection}
                            onUserMove={this.handleMapUserMove}
                          />
                        </section>
                      )}
                    </main>

                    {this.state.realtimeViewMode === "map" && <aside className="ping-details-panel">
                      <div className="panel-title">
                        <span>Live Asset Details</span>
                      </div>

                      {this.renderAssetDetailsContent(selectedAsset, reportDate)}
                    </aside>}
                  </div>
                ) : (
                  !realTimeData.length && !dataLoading && (
                    <div className="realtime-empty-shell">
                      {this.renderRealtimeFilterStrip(
                        activeAssets,
                        realTimeGroups,
                        "empty-filter-strip"
                      )}
                      <NoRecords groupName={currentGroup} />
                    </div>
                  )
                )}

              </div>
            </div>
          </div>
        </Layout>

        <Modal show={this.state.incidentModalOpen} enforceFocus={!this.state.incidentAcknowledgementPending} onHide={()=>{if(!this.state.incidentAcknowledgementSaving)this.setState({incidentModalOpen:false,modalDriverIncident:null,incidentAcknowledgementPending:null});}} dialogClassName="critical-failure-modal-dialog" contentClassName={`critical-failure-modal-content realtime-incident-modal ${this.state.modalDriverIncident?.acknowledgedAt ? "acknowledged" : "unacknowledged"} ${this.state.realtimeTheme}`} centered>
          <Modal.Header closeButton><Modal.Title>{this.state.modalDriverIncident?.acknowledgedAt ? "Incident acknowledged" : "Incident awaiting acknowledgement"}</Modal.Title></Modal.Header>
          <Modal.Body>{this.renderIncidentDetails()}</Modal.Body>
        </Modal>

        <Modal show={!!this.state.incidentAcknowledgementPending && this.state.incidentModalOpen}
          onHide={() => { if (!this.state.incidentAcknowledgementSaving) this.setState({ incidentAcknowledgementPending: null }); }}
          backdrop="static" keyboard={!this.state.incidentAcknowledgementSaving} centered
          style={{ zIndex: 1060 }} backdropClassName="incident-confirmation-backdrop"
          aria-labelledby="incident-confirmation-title">
          <Modal.Header><Modal.Title id="incident-confirmation-title">Confirm acknowledgement</Modal.Title></Modal.Header>
          <Modal.Body>
            <p>You are about to acknowledge incident <strong>{this.state.incidentAcknowledgementPending?.reference || this.state.incidentAcknowledgementPending?.incidentReference}</strong>.</p>
            <p>This lets other users know that you are following up the incident and will check on the driver’s welfare.</p>
            <p>Your name and the acknowledgement time will be recorded.</p>
            {this.state.incidentActionMessage && <p role="alert">{this.state.incidentActionMessage}</p>}
          </Modal.Body>
          <Modal.Footer className="incident-responsibility-actions">
            <button type="button" autoFocus disabled={this.state.incidentAcknowledgementSaving} onClick={() => this.setState({ incidentAcknowledgementPending: null })}>Cancel</button>
            <button type="button" disabled={this.state.incidentAcknowledgementSaving} onClick={this.acknowledgeDriverIncident}>{this.state.incidentAcknowledgementSaving ? "Recording…" : "Confirm acknowledgement"}</button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={this.state.criticalFailureModalOpen}
          onHide={this.closeCriticalFailure}
          dialogClassName="critical-failure-modal-dialog"
          contentClassName={`critical-failure-modal-content ${this.state.realtimeTheme} ${this.criticalFailureModalType()}`}
          centered
        >
          <Modal.Header closeButton><Modal.Title>Critical Checklist Failure</Modal.Title></Modal.Header>
          <Modal.Body>{this.renderCriticalFailureDetails()}</Modal.Body>
        </Modal>

        <Modal
          show={this.isSystemAdmin() && this.state.adminAssetModalOpen && !!selectedAsset}
          onHide={this.closeAdminAssetModal}
          dialogClassName="admin-asset-modal-dialog"
          contentClassName={`admin-asset-modal-content ${this.state.realtimeTheme}`}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Asset Admin Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.renderAdminAssetModalContent(selectedAsset)}
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.assetSettingsModalOpen && !!selectedAsset}
          onHide={this.closeAssetSettingsModal}
          dialogClassName="admin-asset-modal-dialog"
          contentClassName={`admin-asset-modal-content ${this.state.realtimeTheme}`}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>{selectedAsset ? selectedAsset.assetName : "Asset Settings"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.renderAssetSettingsModalContent(selectedAsset)}
          </Modal.Body>
        </Modal>

        <Modal
          show={!!this.state.mapModalAssetId}
          onHide={this.closeAssetMapModal}
          dialogClassName="asset-map-modal-dialog"
          contentClassName={`asset-map-modal-content ${this.state.realtimeTheme}`}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>{modalAsset ? modalAsset.assetName : "Asset Map"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {modalAsset ? (
              <div className="asset-map-modal-body">
                <section className="asset-map-modal-map">
                    <RealMap
                    key={`modal-map-${modalAsset.assetId}`}
                    mapChange=""
                    singleTruckZoom=""
                    followTruckPosition=""
                    realTimeData={[this.applyUserAssetColourOverride(modalAsset)]}
                    isFullScreen={false}
                    scrollLockEnabled={false}
                    visualMode={this.state.realtimeVisualMode}
                    selectedAssetId={modalAsset.assetId}
                    onAssetSelection={this.handleMapAssetSelection}
                  />
                </section>
                <aside className="asset-map-modal-details ping-details-panel">
                  <div className="panel-title">
                    <span>Live Asset Details</span>
                  </div>
                  {this.renderAssetDetailsContent(modalAsset, reportDate)}
                </aside>
              </div>
            ) : (
              <div className="ping-card empty-details">
                <h2>No asset selected</h2>
                <p>Select an asset from the realtime list to inspect it on the map.</p>
              </div>
            )}
          </Modal.Body>
        </Modal>

        <Modal
          show={this.state.userSettingsOpen}
          onHide={this.closeUserSettings}
          dialogClassName="realtime-user-settings-modal-dialog"
          contentClassName={`realtime-user-settings-modal-content ${this.state.realtimeTheme}`}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Map Settings</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this.renderUserSettingsModalContent()}
          </Modal.Body>
        </Modal>

        <Modal
          show={this.isSystemAdmin() && this.state.devPanelOpen}
          onHide={this.toggleDevPanel}
          dialogClassName="dev-settings-modal-dialog"
          contentClassName={`dev-settings-modal-content ${this.state.realtimeTheme}`}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Realtime DEV Settings</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="dev-settings-panel modal-panel">
              <div className="dev-settings-visual-mode">
                <div>
                  <span>Realtime visual mode</span>
                  <small>Controls map icons, asset tiles, and list icons.</small>
                </div>
                <div className="dev-mode-options">
                  {this.getRealtimeVisualModes().map((mode) => (
                    <button
                      type="button"
                      key={mode.key}
                      className={this.state.realtimeVisualMode === mode.key ? "active" : ""}
                      onClick={() => this.setRealtimeVisualMode(mode.key)}
                    >
                      <strong>{mode.title}</strong>
                      <small>{mode.description}</small>
                    </button>
                  ))}
                </div>
              </div>
              <div className="dev-settings-row">
                <span>Address source dots</span>
                <button type="button" className={this.state.showAddressSourceIndicators ? "active" : ""} onClick={this.toggleAddressSourceIndicators}>
                  {this.state.showAddressSourceIndicators ? "On" : "Off"}
                </button>
              </div>
              <div className="dev-settings-row">
                <span>Bypass browser address cache</span>
                <button type="button" className={this.state.bypassBrowserAddressCache ? "active" : ""} onClick={this.toggleBypassBrowserAddressCache}>
                  {this.state.bypassBrowserAddressCache ? "On" : "Off"}
                </button>
              </div>
              <div className="dev-settings-row">
                <span>Force HERE address lookup</span>
                <button type="button" className={this.state.forceHereAddressLookup ? "active danger" : ""} onClick={this.toggleForceHereAddressLookup}>
                  {this.state.forceHereAddressLookup ? "On" : "Off"}
                </button>
              </div>
              <button type="button" className="dev-settings-action" onClick={this.resetAddressDiagnostics}>
                Clear browser address cache
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  realTimeGroup: state.realTimeGroup,
  realTimeGroupId: state.realTimeGroupId,
  realTimeGroupName: state.realTimeGroupName,
  loading: state.loading,
});
const mapDispatchToProps = {
  setRealtimeGroupAction: setRealtimeGroup,
  setRealtimeGroupIdAction: setRealtimeGroupId,
  setRealtimeGroupNameAction: setRealtimeGroupName,
  setLoadingPageAction: setLoadingPage,
};

export default connect(mapStateToProps, mapDispatchToProps)(RealTime);
